import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaFilePdf, FaHome, FaIdCard, FaFileAlt, FaChevronUp, FaChevronDown, FaQuestionCircle, FaArrowLeft, FaCheckCircle, FaShieldAlt, FaTimes, FaExclamation, FaCheck, FaInfoCircle, FaSave, FaFileImport, FaLayerGroup, FaSearch, FaEllipsisV, FaExclamationTriangle, FaEye, FaCircle, FaExchangeAlt, FaOutdent, FaTrash, FaSignOutAlt, FaGlobe, FaDesktop, FaTruck, FaEdit, FaPlusCircle, FaCogs, FaExclamationCircle, FaPlus, FaUserShield, FaUniversalAccess, FaUsers, FaFilter, FaHistory, FaUpload, FaLeaf, FaHandshake, FaSync, FaClock, FaListOl, FaBell, FaEnvelope, FaWrench, FaSortAmountDown, FaFileExport, FaBoxes, FaBars, FaChartBar, FaDownload, FaTable, FaSort, FaColumns, FaPrint, FaLightbulb, FaChartLine, FaSlidersH, FaCalendarAlt, FaMagic, FaMousePointer, FaFile, FaMoneyBill, FaSortAmountUp } from 'react-icons/fa';
import Sidebar from './sidebar';
import Navbar from "./navbar";
import useAuth from './useAuth';

//Accueil 
import AccueilMenuImg from '../../assets/images/manuel_utilisation/accueil-menu.png';
import AccueilRapportImg from '../../assets/images/manuel_utilisation/accueil-rapport-statistiques.png';
import AccueilEnrolementImg from '../../assets/images/manuel_utilisation/accueil-enrolement.png';
import AccueilSuiviDocImg from '../../assets/images/manuel_utilisation/accueil-suivi-documents.png';
import AccueilToursImg from '../../assets/images/manuel_utilisation/accueil-gestion-tours.png';
import AccueilAdminImg from '../../assets/images/manuel_utilisation/accueil-administration.png';

// Tableau de bord
import tableauBordImg from '../../assets/images/manuel_utilisation/tableau-de-bord/tableau-bord.png';
import entreesImg from '../../assets/images/manuel_utilisation/tableau-de-bord/tableau-bord.png';
import sortiesImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-sorties.png';
import financierImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-financier.png';
import lettreVoitureImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-lettres.png';
import fretImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets.png';
import fretChargeImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets-charges.png';
import filtreTypeImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets-charges.png';
import filtreDateImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets-charges.png';
import filtresAvancesImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets-charges.png';
import colonnesImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets-charges.png';
import triImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets-charges.png';
import exportImg from '../../assets/images/manuel_utilisation/tableau-de-bord/statistiques-frets-charges.png';
//Enrolement
import creerEnrolementImg from '../../assets/images/manuel_utilisation/enrolement/creer-enrolement.png';
import structureLeftImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-structure-left.PNG';
import structureRightImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-structure-right.PNG';
import BtnSygfrModalImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-sygfr-modal.PNG';
import ModalSygfrImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-modal-sygfr.png';
import RemplissageSygfrImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-remplissage-automatique.png';
import tabsImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-tabs.png';
import tabsGreenImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-tabs-vert.png';
import enrolementTerminerImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-terminer.png';
import enrolementTerminerConfirmerImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-terminer-confirmer.png';
import messageErreurImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-alerte-erreur.png';
import premierEnregistrementImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-premier-enregistrement.png';
import enrolementActionsImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-actions-liste.png';
import btnEnrolerImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-btn-enroler.png';
import enrolerActions2Img from '../../assets/images/manuel_utilisation/enrolement/enrolement-actions2.png';
import messageSuccesImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-alerte-succes.png';
import enrolementRechercheImg from '../../assets/images/manuel_utilisation/enrolement/enrolement-rechercher.PNG';
//Suivi Documents
import SuiviDocsImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-liste.JPG';
import SuiviDocsBadgeRougeImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-liste-badge-rouge.png';
import SuiviDocsRechercheImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-rechercher.JPG';
import SuiviDocsRechercheAvanceeImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-recherche-avancee.jpg';
import SuiviDocsFiltreImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-filtre.png';
import SuiviDocsBtnConsulterImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-btn-consulter.png';
import SuiviDocsBtnRenouvelerImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-btn-renouveler.png';
import SuiviDocsConsulterImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter.png';
import SuiviDocsConsulterGaucheImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-gauche.png';
import SuiviDocsConsulterDroiteImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-droite.png';
import SuiviDocsConsulterTabsColorImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-tabs-color.png';
import SuiviDocsConsulterBadgeExpireImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-badge-expire.png';
import SuiviDocsConsulterCTImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-consulter-CT.png';
import SuiviDocsRenouvelerImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler.png';
import SuiviDocsRenouvelerGaucheImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-gauche.png';
import SuiviDocsRenouvelerDroiteImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-droite.png';
import SuiviDocsRenouvelerCTImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-CT.png';
import SuiviDocsRenouvelerConfirmerImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-confirmer.png';
import SuiviDocsRenouvelerErreurImg from '../../assets/images/manuel_utilisation/suivi-documents/suivi-docs-renouveler-message-erreur.png';
//Tours nationaux
import MenuToursNationauxImg from '../../assets/images/manuel_utilisation/tours/menu-gestion-tours-nationaux.png';
import ToursNationauxListeImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-liste.png';
import ToursNationauxListeChargementImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-liste-chargement.png';
import ToursNationauxActionsImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-actions.png';
import ToursNationauxNouveauImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-nouvelle-entree.png';
import ToursNationauxEcranImg from '../../assets/images/manuel_utilisation/tours/nationaux/tours-nationaux-ecran.png';
//Tours internationaux
import MenuToursInternationauxImg from '../../assets/images/manuel_utilisation/tours/menu-gestion-tours-internationaux.png';
import ToursInternationauxListeImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-liste.png';
import ToursInternationauxListeChargementImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-liste-chargement.png';
import ToursInternationauxActionsImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-actions.png';
import ToursInternationauxNouveauImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-nouvelle-entree.png';
import ToursInternationauxEcranImg from '../../assets/images/manuel_utilisation/tours/internationaux/tours-internationaux-ecran.png';


// Mise en file
import MiseFileEcranImg from '../../assets/images/manuel_utilisation/tours/tours-mise en file.JPG';
import SelectionParcImg from '../../assets/images/manuel_utilisation/tours/tours-selection-parc.JPG';

//Frets
import MenuToursFretImg from '../../assets/images/manuel_utilisation/tours/menu-gestion-tours-fret.png';
import ToursFretListeImg from '../../assets/images/manuel_utilisation/tours/fret/gestion-des-frets.png';
import ToursFretQuotasImg from '../../assets/images/manuel_utilisation/tours/fret/fret-quotas.png';
import ToursFretActionsImg from '../../assets/images/manuel_utilisation/tours/fret/fret-actions.png';
import ToursFretNouveauImg from '../../assets/images/manuel_utilisation/tours/fret/fret-nouveau.png';
import ToursFretModifierImg from '../../assets/images/manuel_utilisation/tours/fret/fret-modifier.png';

//Paiement 
import MenuToursPaiementImg from '../../assets/images/manuel_utilisation/tours/menu-gestion-tours-paiement.png';

//Administration
//Administration-Groupes
import AdminMenuGroupes from '../../assets/images/manuel_utilisation/administration/menu-admin-groupes.png';
import GroupesListe from '../../assets/images/manuel_utilisation/administration/groupes/admin-groupes-liste.png';
import GroupesAjouter from '../../assets/images/manuel_utilisation/administration/groupes/admin-groupes-modal-ajouter.png';
import GroupesSupprimer from '../../assets/images/manuel_utilisation/administration/groupes/admin-groupes-modal-supprimer.png';
import GroupesListeSelection from '../../assets/images/manuel_utilisation/administration/groupes/admin-groupes-liste-selection.png';
import GroupesListeSelectionConfigurer from '../../assets/images/manuel_utilisation/administration/groupes/admin-groupes-liste-selection-configurer.png';
import GroupesListeSelectionSupprimer from '../../assets/images/manuel_utilisation/administration/groupes/admin-groupes-liste-selection-supprimer.png';
import GroupesConfigurerInfos from '../../assets/images/manuel_utilisation/administration/groupes/admin-groupes-configurer-infos.png';
import GroupesConfigurerAcces from '../../assets/images/manuel_utilisation/administration/groupes/admin-groupes-configurer-acces.png';
import GroupesConfigurerMembres from '../../assets/images/manuel_utilisation/administration/groupes/admin-groupes-configurer-membres.png';
//Administration-Utilisateurs
import AdminMenuUtilisateurs from '../../assets/images/manuel_utilisation/administration/menu-admin-utilisateurs.png';
import UtilisateursListe from '../../assets/images/manuel_utilisation/administration/utilisateurs/admin-utilisateurs-liste.png';
import UtilisateursListeSelection from '../../assets/images/manuel_utilisation/administration/utilisateurs/admin-utilisateurs-liste-selection.png';
//Administration-Enrolements
import AdminMenuEnrolements from '../../assets/images/manuel_utilisation/administration/menu-admin-enrolements.png';
import AdminEnrolementsListe from '../../assets/images/manuel_utilisation/administration/enrolements/admin-enrolements-liste.png';
import AdminEnrolementsListeActions from '../../assets/images/manuel_utilisation/administration/enrolements/admin-enrolements-actions.png';
import AdminEnrolementsModifier from '../../assets/images/manuel_utilisation/administration/enrolements/admin-enrolements-modifier.png';

//Administration-SuiviDocuments
import AdminMenuSuiviDocuments from '../../assets/images/manuel_utilisation/administration/menu-admin-suivi-documents.png';
import AdminSuiviDocsImg from '../../assets/images/manuel_utilisation/administration/suivi-documents/admin-suivi-documents-liste.png';
import AdminSuiviDocsActionsImg from '../../assets/images/manuel_utilisation/administration/suivi-documents/admin-suivi-documents-liste-actions.png';
import AdminSuiviDocsRechercheImg from '../../assets/images/manuel_utilisation/administration/suivi-documents/admin-suivi-documents-rechercher.png';
import AdminSuiviDocsRechercheAvanceeImg from '../../assets/images/manuel_utilisation/administration/suivi-documents/admin-suivi-documents-recherche-avancee.png';
import AdminSuiviDocsFiltreImg from '../../assets/images/manuel_utilisation/administration/suivi-documents/admin-suivi-documents-filtre.png';
import AdminSuiviDocsBtnConsulterImg from '../../assets/images/manuel_utilisation/administration/suivi-documents/admin-suivi-documents-consulter.png';

//Administration-Elementaires
import AdminMenuElementaires from '../../assets/images/manuel_utilisation/administration/menu-admin-elementaires.png';
import CartesMenuElementaires from '../../assets/images/manuel_utilisation/administration/elementaires/cartes-menu-elementaires.png';
import TypeVehicules from '../../assets/images/manuel_utilisation/administration/elementaires/types-vehicule.png';
import Assureurs from '../../assets/images/manuel_utilisation/administration/elementaires/assureurs.png';
import CentreFret from '../../assets/images/manuel_utilisation/administration/elementaires/centre-fret.png';
import Parcs from '../../assets/images/manuel_utilisation/administration/elementaires/parcs.png';
import BailleurFret from '../../assets/images/manuel_utilisation/administration/elementaires/bailleur-fret.png';
import Conducteurs from '../../assets/images/manuel_utilisation/administration/elementaires/conducteurs.png';
import NatureFret from '../../assets/images/manuel_utilisation/administration/elementaires/nature-fret.png';

//Administration-Paramètres
import AdminMenuParametres from '../../assets/images/manuel_utilisation/administration/menu-admin-parametres.png';
import AdminParametresGeneral from '../../assets/images/manuel_utilisation/administration/parametres/admin-parametres-general.png';
import AdminParametresNotifications from '../../assets/images/manuel_utilisation/administration/parametres/admin-parametres-notification-expiration.png';
import AdminParametresConfigarion from '../../assets/images/manuel_utilisation/administration/parametres/admin-parametres-configuration-ecrans.png';

//Administration-Journalisation
import AdminMenuJournalisation from '../../assets/images/manuel_utilisation/administration/menu-admin-journalisation.png';
import AdminJournalisation from '../../assets/images/manuel_utilisation/administration/journalisation/admin-journalisation-liste.png';

//Administration-Corbeille
import AdminMenuCorbeille from '../../assets/images/manuel_utilisation/administration/menu-admin-corbeille.png';
import AdminCorbeilleMenu from '../../assets/images/manuel_utilisation/administration/corbeille/corbeille-menu.png';
import AdminCorbeilleMenuEnrolement from '../../assets/images/manuel_utilisation/administration/corbeille/corbeille-menu-enrolement.png';
import AdminCorbeilleMenuFret from '../../assets/images/manuel_utilisation/administration/corbeille/corbeille-menu-fret.png';
import AdminCorbeilleEnrolement from '../../assets/images/manuel_utilisation/administration/corbeille/corbeille-enrolement.png';
import AdminCorbeilleEnrolementActions from '../../assets/images/manuel_utilisation/administration/corbeille/corbeille-enrolement-actions.png';
import AdminCorbeilleFret from '../../assets/images/manuel_utilisation/administration/corbeille/corbeille-fret.png';
import AdminCorbeilleFretActions from '../../assets/images/manuel_utilisation/administration/corbeille/corbeille-fret-actions.png';


import { FaCircleCheck, FaCircleExclamation, FaCircleXmark, FaRoadBarrier, FaBook } from 'react-icons/fa6';
import { Button } from 'react-bootstrap';
import { BsBank, BsCarFront, BsPersonBadge, BsShop } from 'react-icons/bs';
import { Link } from 'react-router-dom';
import Footer from './footer';

const ManuelUtilisationAdmin = ({ titre }) => {
    useAuth();
    const user_id = localStorage.getItem("userId");
    const navigate = useNavigate();
    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Manuel d'utilisation";
        }
    }, [user_id]);

    const location = useLocation(); // Ajoutez cette ligne

    const [activeModule, setActiveModule] = useState(
        location.state?.fromModule || 'introduction'
    );
    const [activeSection, setActiveSection] = useState(
        location.state?.fromSection || null
    );

    const [showInfo, setShowInfo] = useState(false);
    // const [openSections, setOpenSections] = useState({});

    const [openSections, setOpenSections] = useState(() => {
        // Ouvrir par défaut le module actif
        const initialOpen = {};
        if (location.state?.fromModule) {
            initialOpen[location.state.fromModule] = true;
        } else {
            initialOpen['introduction'] = true; // ou le module par défaut
        }
        return initialOpen;
    });

    // Ouvrir automatiquement la section correspondante
    useEffect(() => {
        if (location.state?.fromModule) {
            setActiveModule(location.state.fromModule);
            setOpenSections(prev => ({
                ...prev,
                [location.state.fromModule]: true
            }));

            if (location.state?.fromSection) {
                setActiveSection(location.state.fromSection);
            }
        }
    }, [location.state]);

    // const toggleSection = (sectionId) => {
    //     setOpenSections(prev => ({
    //         ...prev,
    //         [sectionId]: !prev[sectionId]
    //     }));

    //     // Si on ouvre une section, on définit la première sous-section comme active
    //     if (!openSections[sectionId]) {
    //         const module = modules.find(m => m.id === sectionId);
    //         if (module?.sections?.length > 0) {
    //             setActiveSection(module.sections[0].id);
    //         }
    //     }
    // };
    const toggleSection = (sectionId) => {
        setOpenSections(prev => ({
            ...prev,
            [sectionId]: !prev[sectionId]
        }));

        // Garder toujours une section active, même quand on ferme
        if (!openSections[sectionId]) {
            const module = modules.find(m => m.id === sectionId);
            if (module?.sections?.length > 0) {
                setActiveSection(module.sections[0].id);
            }
        }
    };

    useEffect(() => {
        const scrollToElement = (id, offset = 20) => {
            const element = document.getElementById(id);
            if (!element) return;

            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            // Vérifie si l'élément est déjà visible avec l'offset
            const isVisible = (
                elementPosition >= offset &&
                elementPosition <= (window.innerHeight - offset)
            );

            if (!isVisible) {
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        };

        if (activeSection) {
            setTimeout(() => {
                scrollToElement(`section-${activeSection}`);
            }, 300);
        } else if (activeModule) {
            const module = modules.find(m => m.id === activeModule);
            const sectionId = module?.sections?.length > 0 ? module.sections[0].id : null;

            setTimeout(() => {
                if (sectionId) {
                    scrollToElement(`section-${sectionId}`);
                } else {
                    scrollToElement(`module-${activeModule}`);
                }
            }, 300);
        }
    }, [activeModule, activeSection]);

    const modules = [
        {
            id: 'introduction',
            name: 'Introduction',
            icon: <FaBook className="me-2" />,
            content: (
                <div className="space-y-6">
                    <h2 className="text-2xl font-bold text-blue-800 mb-6">Bienvenue dans le manuel d'utilisation de TransportPro</h2>

                    <div className="">
                        <h4 className="text-xl font-semibold text-blue-700 mb-2 flex items-center">
                            <FaInfoCircle className="mr-3 text-blue-500" />
                            À propos de ce manuel
                        </h4>
                        <p className="mb-2 text-gray-700 leading-relaxed">
                            Ce guide complet a été conçu pour vous accompagner pas à pas dans la prise en main de l'application TransportPro.
                            Il détaille l'ensemble des fonctionnalités disponibles, avec des captures d'écran annotées et des explications
                            claires pour chaque processus métier.
                        </p>
                        <p className="mb-4 text-gray-700 leading-relaxed">
                            Le manuel est organisé en modules thématiques correspondant aux principales sections de l'application.
                            Utilisez le menu de navigation à gauche pour accéder directement aux fonctionnalités qui vous intéressent.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                        <div className="">
                            <h4 className="text-lg font-semibold mb-2 text-gray-800 flex items-center">
                                <FaCheckCircle className="mr-2 text-green-500" />
                                Comment utiliser ce manuel
                            </h4>
                            <ul className="list-disc pl-5 space-y-2 text-gray-700">
                                <li>Cliquez sur les modules dans le menu latéral pour accéder aux différentes sections</li>
                                <li>Les icônes <FaChevronDown className="inline mx-1" /> permettent de développer les sous-sections</li>
                                <li>Les captures d'écran des processus y sont insérées</li>
                            </ul>
                        </div>
                    </div>

                    <div className="">
                        <h4 className="text-xl font-semibold mb-2 text-gray-800">Structure de l'application</h4>
                        <p className="mb-2 text-gray-700">
                            TransportPro est organisé autour des modules suivants :
                        </p>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <div className="ml-3">
                                <div className="flex items-center mb-2">
                                    <FaChartBar className="text-blue-500 mr-2" />
                                    <h5 className="font-bold text-blue-800">Rapport statistiques</h5>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Suivi global de la flotte
                                </p>
                            </div>
                            <div className="ml-3">
                                <div className="flex items-center mb-2">
                                    <FaTruck className="text-green-500 mr-2" />
                                    <h5 className="font-bold text-green-800">Enrôlement</h5>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Interface complète pour l'enregistrement et la gestion des véhicules et de leurs documents.
                                </p>
                            </div>
                            <div className="ml-3">
                                <div className="flex items-center mb-2">
                                    <FaFileAlt className="text-purple-500 mr-2" />
                                    <h5 className="font-bold text-purple-800">Suivi Documents</h5>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Gestion proactive des échéances documentaires avec système d'alertes visuelles.
                                </p>
                            </div>
                            <div className="ml-3">
                                <div className="flex items-center mb-2">
                                    <FaExchangeAlt className="text-purple-500 mr-2" />
                                    <h5 className="font-bold text-purple-800">Gestion des tours</h5>
                                </div>
                                <p className="text-sm text-gray-600">
                                    Enregistrement FIFO des camions sur le pack, déclaration des frets (nature, trajet) et assignation optimisée pour le transport.
                                </p>
                            </div>

                        </div>
                        <img src={AccueilMenuImg} alt="Accueil"
                            className="img-fluid mb-6 border rounded-lg shadow-md"
                        />
                    </div>
                </div>
            ),
            sections: []
        },
        {
            id: 'tableau-bord',
            name: 'Rapport et statistiques',
            icon: <FaHome className="me-2" />,
            sections: [
                {
                    id: 'dashboard-overview',
                    name: 'Vue générale',
                    content: (
                        <div className="space-y-8">
                            <h2 className="text-2xl font-bold text-blue-800 mb-4">Rapport et statistiques</h2>

                            <p className="text-gray-700 mb-2">
                                Le module de rapports et statistiques vous offre une vision complète et analysée de l'activité de transport dans les parcs.
                                Vous pouvez y suivre les indicateurs clés de performance à travers différents types de rapports.
                            </p>

                            <img src={tableauBordImg} alt="Vue d'ensemble du tableau de bord"
                                className="img-fluid mb-6 border rounded-lg shadow-md" />

                            <div className="bg-blue-50 border-l-4 border-blue-400 p-1 rounded-lg mb-6">
                                <div className="flex items-start">
                                    Le module est organisé en onglets thématiques. Commencez par sélectionner l'onglet correspondant au type de statistique qui vous intéresse, puis affinez les résultats avec les filtres disponibles.

                                </div>
                            </div>

                            <h3 className="text-xl font-semibold mb-4 flex items-center text-blue-700">
                                <FaFilter className="mr-2 text-blue-500" />
                                Navigation entre les différents rapports
                            </h3>

                            <p className="text-gray-700 mb-4">
                                Le module propose 6 types de rapports accessibles via des onglets :
                            </p>

                            <div className="space-y-10">
                                {/* Onglet Véhicules Entrés */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mb-1 text-blue-600">Véhicules entrés</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport liste tous les véhicules ayant accédé à vos parcs sur la période sélectionnée.
                                            Vous y trouverez des informations détaillées sur chaque camion, incluant :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>La date et heure d'entrée</li>
                                            <li>Les caractéristiques du véhicule (type, immatriculation)</li>
                                            <li>Le parking d'affectation</li>
                                            <li>Le statut du droit de parking</li>
                                            <li>La charge utile transportée</li>
                                            <li>Le statut actuel du véhicule</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={entreesImg} alt="Rapport véhicules entrés"
                                            className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Onglet Véhicules Sortis */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Véhicules sortis</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport recense les véhicules ayant quitté vos installations, avec des données sur :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>Les dates d'entrée et de sortie</li>
                                            <li>La durée de stationnement</li>
                                            <li>Les informations sur le véhicule et son propriétaire</li>
                                            <li>Le statut au moment de la sortie</li>
                                            <li>Les éventuelles marchandises transportées</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={sortiesImg} alt="Rapport véhicules sortis"
                                            className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Onglet Point Financier */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Point financier</h4>
                                        <p className="text-gray-700 mb-1">
                                            Pour le suivi des recettes liées aux droits de parking, ce rapport fournit :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>Un résumé des droits payés et impayés</li>
                                            <li>Le décompte des véhicules avec leur statut financier</li>
                                            <li>Des totaux par type de véhicule ou parking</li>
                                            <li>Des indicateurs de recouvrement</li>
                                        </ul>
                                        <p className="text-gray-700 text-sm mt-2">
                                            <strong>Note :</strong> Les totaux sont affichés en en-tête du rapport.
                                        </p>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={financierImg} alt="Rapport point financier" className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Onglet Lettres de Voiture */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Lettres de voiture</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport vous permet de suivre la conformité documentaire des véhicules avec :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>Le statut de la lettre de voiture (présente/absente)</li>
                                            <li>La date de délivrance le cas échéant</li>
                                            <li>Le lien avec les véhicules concernés</li>
                                            <li>Un décompte par statut documentaire</li>
                                        </ul>
                                        <p className="text-gray-700 text-sm mt-2">
                                            <strong>Note :</strong> Les totaux (documents présents/absents) sont affichés en en-tête.
                                        </p>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={lettreVoitureImg} alt="Rapport lettres de voiture"
                                            className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Onglet Fret */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Fret</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport donne une vision des marchandises à transporter, avec :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>La référence et le type de fret</li>
                                            <li>Le trajet complet (origine-destination)</li>
                                            <li>La nature des marchandises</li>
                                            <li>Le bailleur concerné</li>
                                            <li>La charge utile totale</li>
                                            <li>Le statut actuel (en attente, assigné, etc.)</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={fretImg} alt="Rapport fret" className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>

                                {/* Onglet Frets Chargés */}
                                <div className="flex flex-col md:flex-row gap-6">
                                    <div className="md:w-1/2">
                                        <h4 className="text-lg font-semibold mt-4 mb-1 text-blue-600">Frets chargés</h4>
                                        <p className="text-gray-700 mb-1">
                                            Ce rapport montre les marchandises effectivement chargées et les véhicules associés :
                                        </p>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700 mb-2">
                                            <li>Les détails du fret transporté</li>
                                            <li>Les informations sur le véhicule affecté</li>
                                            <li>Les dates de départ et d'arrivée</li>
                                            <li>Le type de quota utilisé</li>
                                            <li>La localisation actuelle (parking)</li>
                                            <li>La date de sortie réelle</li>
                                        </ul>
                                    </div>
                                    <div className="md:w-1/2">
                                        <img src={fretChargeImg} alt="Rapport fret chargé" className="img-fluid mb-6 border rounded-lg shadow-md" />
                                    </div>
                                </div>
                            </div>

                            <h3 className="text-xl font-semibold mt-4 mb-2 flex items-center text-blue-700">
                                <FaSlidersH className="mr-2 text-blue-500" />
                                Fonctionnalités avancées
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {/* Colonne 1 */}
                                <div className="space-y-6">
                                    <div className="bg-white p-2">
                                        <h4 className="font-medium mb-2 text-blue-600 flex items-center">
                                            <FaSearch className="mr-2" />
                                            Recherche et filtres
                                        </h4>
                                        <div className="space-y-3">
                                            <div>
                                                <h5 className="font-medium text-gray-700">Recherche simple</h5>
                                                <p className="text-gray-700 text-sm">
                                                    Utilisez la barre de recherche en haut à droite pour filtrer les données affichées dans le tableau.
                                                </p>
                                            </div>

                                            <div>
                                                <h5 className="font-medium text-gray-700">Recherche avancée</h5>
                                                <p className="text-gray-700 text-sm">
                                                    Cliquez sur "Recherche avancée" pour accéder à des filtres spécifiques :
                                                </p>
                                                <ul className="list-disc pl-5 text-gray-700 text-sm space-y-1">
                                                    <li>Par type de parc (national/international)</li>
                                                    <li>Par parking spécifique</li>
                                                    <li>Par statut de droit de parking</li>
                                                    <li>Par type de véhicule</li>
                                                    <li>Par période (jour, semaine, mois ou personnalisée)</li>
                                                    <li>Pour les frets : par nature de fret et bailleur</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="bg-white p-2">
                                        <h4 className="font-medium mb-2 text-blue-600 flex items-center">
                                            <FaEye className="mr-2" />
                                            Personnalisation de l'affichage
                                        </h4>
                                        <p className="text-gray-700 text-sm mb-2">
                                            Cliquez sur "Visibilité" pour choisir les colonnes à afficher ou masquer dans le tableau.
                                        </p>
                                        <p className="text-gray-700 text-sm">
                                            Vous pouvez aussi :
                                        </p>
                                        <ul className="list-disc pl-5 text-sm ">
                                            <li>Tout sélectionner/désélectionner en un clic</li>
                                            <li>Personnaliser l'affichage pour chaque type de rapport</li>
                                        </ul>
                                    </div>
                                </div>

                                {/* Colonne 2 */}
                                <div className="space-y-6">
                                    <div className="bg-white p-2">
                                        <h4 className="font-medium mb-1 text-blue-600 flex items-center">
                                            <FaSortAmountDown className="mr-2" />
                                            Tri des données
                                        </h4>
                                        <p className="text-gray-700 text-sm">
                                            Cliquez sur les en-têtes de colonne pour trier les données par ordre croissant ou décroissant.
                                        </p>
                                        <p className="text-gray-700 text-sm mt-1">
                                            Un indicateur visuel (<FaSortAmountDown className="inline" /> ou <FaSortAmountUp className="inline" />) montre le sens de tri actif.
                                        </p>
                                    </div>

                                    <div className="bg-white p-2">
                                        <h4 className="font-medium mb-1 text-blue-600 flex items-center">
                                            <FaFilePdf className="mr-2" />
                                            Export des données
                                        </h4>
                                        <p className="text-gray-700 text-sm">
                                            Utilisez le bouton "Télécharger rapport" pour exporter les données affichées au format PDF.
                                        </p>
                                        <p className="text-gray-700 text-sm">
                                            <strong>Note :</strong> L'export prend en compte :
                                        </p>
                                        <ul className="list-disc pl-5 text-gray-700 text-sm space-y-1">
                                            <li>Les filtres appliqués</li>
                                            <li>Les colonnes visibles</li>
                                            <li>Le tri actif</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-blue-50 border-l-4 border-blue-400 p-2 rounded-lg mt-6">
                                <div className="flex items-start">
                                    <p className="text-gray-700 text-sm mt-1">
                                        Chaque onglet affiche le nombre d'éléments correspondants entre parenthèses.
                                        Ce compteur est mis à jour en fonction des filtres appliqués.
                                    </p>
                                    <p className="text-gray-700 text-sm mt-1">
                                        Les rapports "Point financier" et "Lettres de voiture" incluent des totaux synthétiques en haut du tableau.
                                    </p>
                                </div>
                            </div>
                        </div>
                    )
                }
            ]
        },
        // {
        //     id: 'enrolement',
        //     name: 'Enrôlement',
        //     icon: <FaTruck className="me-2" />,
        //     sections: [
        //         {
        //             id: 'nouvel-enrolement',
        //             name: 'Nouvel enrôlement',
        //             content: (
        //                 <div>
        //                     <h2 className="text-lg font-bold mb-3">Enrôlement des véhicules</h2>
        //                     <p className="mb-4 text-gray-700">
        //                         Cette section vous guide dans le processus d'enrôlement d'un nouveau véhicule dans le système TransportPro.
        //                         L'enrôlement consiste à enregistrer toutes les informations et documents obligatoires relatifs à un véhicule de transport.
        //                     </p>
        //                     <p className="mb-4 text-gray-700">
        //                         Sur la page de la liste des enrolements, clisuez sur le bouton Enroler à droite
        //                     </p>
        //                     <img
        //                         src={btnEnrolerImg}
        //                         alt="Interface de nouvel enrôlement"
        //                         className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                     />
        //                     <p className="mb-4 text-gray-700">
        //                         Vous serez redirigé sur l'interface d'enrolement
        //                     </p>
        //                     <img
        //                         src={creerEnrolementImg}
        //                         alt="Interface de nouvel enrôlement"
        //                         className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                     />

        //                     {/* Section 1: Structure générale */}
        //                     <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaLayerGroup className="mr-2 text-blue-500" />
        //                             1. Structure de la page
        //                         </h5>
        //                         <p className="mb-3 text-gray-700">
        //                             L'interface d'enrôlement est divisée en deux parties principales pour une meilleure ergonomie :
        //                         </p>
        //                         <div className="grid grid-cols-2 gap-4 mb-3">
        //                             <div>
        //                                 <img
        //                                     src={structureLeftImg}
        //                                     alt="Partie formulaire"
        //                                     className="img-fluid mb-1 border rounded-lg shadow-sm"
        //                                 />
        //                                 <p className="text-sm text-center mt-1 mb-4 text-gray-600">
        //                                     Partie gauche : Formulaire de saisie
        //                                 </p>
        //                                 <p className="text-sm text-gray-700">
        //                                     Cette zone contient tous les champs à remplir, organisés par onglets thématiques correspondant aux différents documents requis.
        //                                     Les champs obligatoires sont marqués d'un astérisque rouge (*).
        //                                 </p>
        //                             </div>
        //                             <div>
        //                                 <img
        //                                     src={structureRightImg}
        //                                     alt="Partie visualisation"
        //                                     className="img-fluid mb-2 border rounded-lg shadow-sm"
        //                                 />
        //                                 <p className="text-sm text-center mt-1 mb-4 text-gray-600">
        //                                     Partie droite : Visualisation des documents
        //                                 </p>
        //                                 <p className="text-sm text-gray-700">
        //                                     Cet espace permet de prévisualiser les documents importés (cartes grises, assurances, etc.) avant validation.
        //                                     Vous pouvez zoomer et naviguer dans les PDF directement depuis cette interface.
        //                                 </p>
        //                             </div>
        //                         </div>
        //                         <ul className="list-disc pl-5 space-y-2">
        //                             <li><strong>Barre d'outils supérieure</strong> : Contient les boutons pour importer depuis SYGFR et réinitialiser le formulaire</li>
        //                             <li><strong>Onglets documentaires</strong> : Permettent un accès rapide aux différentes sections (Carte Grise, Assurance, etc.)</li>
        //                             <li><strong>Prévisualisation</strong> : Affiche dynamiquement les PDF/images des documents chargés pour vérification</li>
        //                         </ul>
        //                     </div>

        //                     {/* Section 2: Import SYGFR */}
        //                     <div className="mb-5 p-4 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaFileImport className="mr-2 text-green-600" />
        //                             2. Importation depuis SYGFR
        //                         </h5>
        //                         <p className="mb-3 text-gray-700">
        //                             TransportPro permet d'importer automatiquement les données des véhicules depuis le système SYGFR (Système de Gestion des Flottes Routières),
        //                             ce qui évite une saisie manuelle fastidieuse et réduit les risques d'erreur.
        //                         </p>
        //                         <div className="grid grid-cols-3 gap-3 text-sm">
        //                             <div className="">
        //                                 <div className="font-semibold text-blue-600">1. Lancement</div>
        //                                 <p>Cliquez sur "Importer les données" pour accéder à la liste des véhicules enregistrés dans SYGFR</p>
        //                                 <img
        //                                     src={BtnSygfrModalImg}
        //                                     alt="Bouton SYGFR"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                             </div>
        //                             <div className="">
        //                                 <div className="font-semibold text-blue-600">2. Sélection</div>
        //                                 <p>Choisissez un véhicule dans la liste proposée. Le système affiche les cartes nationale et internationale disponibles.</p>
        //                                 <img
        //                                     src={ModalSygfrImg}
        //                                     alt="Modal SYGFR"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                             </div>
        //                             <div className="">
        //                                 <div className="font-semibold text-blue-600">3. Intégration</div>
        //                                 <p>Les données du véhicule sélectionné sont automatiquement importées dans les champs correspondants du formulaire.</p>
        //                                 <img
        //                                     src={RemplissageSygfrImg}
        //                                     alt="Modal SYGFR"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                             </div>
        //                         </div>
        //                         <div className="mt-1 p-3 bg-yellow-50 border-l-4 border-yellow-400">
        //                             <FaInfoCircle className="inline mr-2 text-yellow-600" />
        //                             Le système détecte automatiquement si les cartes nationale et internationale sont jumelées et remplit les champs correspondants.
        //                             Si une carte manque, un message d'avertissement vous en informe.
        //                         </div>
        //                     </div>

        //                     {/* Section 3: Onglets documentaires */}
        //                     <div className="mb-6 p-4 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaFileAlt className="mr-2 text-purple-500" />
        //                             3. Gestion des onglets
        //                         </h5>
        //                         <img
        //                             src={tabsImg}
        //                             alt="Onglets documentaires"
        //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                         />
        //                         <p className="mb-3 text-gray-700">
        //                             Les 8 onglets représentent les différents documents à fournir pour un enrôlement complet.
        //                             Chaque icône change de couleur pour indiquer l'état de complétion de la section correspondante :
        //                         </p>
        //                         <div className="d-flex justify-content-around mb-3">
        //                             <div className="text-center">
        //                                 <FaCircleCheck style={{ color: "green", size: 30 }} className="text-green" />
        //                                 <p className="text-xs mt-1">Complet</p>
        //                             </div>
        //                             <div className="text-center">
        //                                 <FaCircleExclamation style={{ color: "orange" }} className="text-orange" />
        //                                 <p className="text-xs mt-1">Partiel</p>
        //                             </div>
        //                             <div className="text-center">
        //                                 <FaCircleXmark style={{ color: "black" }} className="text-dark" />
        //                                 <p className="text-xs mt-1">Vide</p>
        //                             </div>
        //                         </div>
        //                         <p className="text-sm text-gray-700">
        //                             <strong>Noir</strong> : Aucun champ n'est rempli pour cet onglet<br />
        //                             <strong>Orange</strong> : Certains champs sont remplis mais il en manque<br />
        //                             <strong>Vert</strong> : Tous les champs obligatoires sont remplis
        //                         </p>
        //                     </div>

        //                     {/* Section 4: Validation */}
        //                     <div className="p-4 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaShieldAlt className="mr-2 text-red-500" />
        //                             4. Validation et enregistrement
        //                         </h5>
        //                         <p className="mb-3 text-gray-700">
        //                             Avant de pouvoir enregistrer définitivement l'enrôlement, tous les onglets doivent être passés au vert,
        //                             indiquant que toutes les informations obligatoires ont été fournies.
        //                         </p>
        //                         <img
        //                             src={tabsGreenImg}
        //                             alt="Onglets verts"
        //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                         />
        //                         <div className="grid grid-cols-2 gap-4">
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaCheckCircle className="mr-1 text-green-500" />
        //                                     Contrôles automatiques
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Le système effectue plusieurs vérifications automatiques lors de la saisie pour garantir la cohérence des données :
        //                                 </p>
        //                                 <img
        //                                     src={messageErreurImg}
        //                                     alt="Messages d'erreurs'"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                                 <ul className="list-disc pl-5 text-sm space-y-1">
        //                                     <li>Format des emails et numéros de téléphone</li>
        //                                     <li>Cohérence des dates (pas de date d'expiration antérieure à aujourd'hui)</li>
        //                                     <li>Champs obligatoires non vides</li>
        //                                     <li>Format des numéros de carte et d'immatriculation</li>
        //                                 </ul>
        //                             </div>
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaSave className="mr-1 text-blue-500" />
        //                                     Actions finales
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Vous pouvez enregistrer l'enrôlement en cliquant sur le bouton "Enregistrer" pour pouvoir y revenir plus tard.
        //                                 </p>
        //                                 <img
        //                                     src={messageSuccesImg}
        //                                     alt="Messages de succès'"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                                 <p className="mb-3 text-gray-700">
        //                                     Après le premier enregistrement, la page bascule en mode modification.
        //                                 </p>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Si vous cliquez sur "Retour", vous serez redirigé vers la liste des enrôlements avec le dernier enregistrement en première position.
        //                                 </p>
        //                                 <img
        //                                     src={premierEnregistrementImg}
        //                                     alt="Messages d'erreurs'"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //             )
        //         },
        //         {
        //             id: 'modifier-enrolement',
        //             name: 'Modifier enrôlement',
        //             content: (
        //                 <div>
        //                     <h2 className="text-lg font-bold mb-3">Modification d'un enrôlement existant</h2>
        //                     <p className="mb-4 text-gray-700">
        //                         Cette section explique comment modifier un enrôlement déjà créé mais non finalisé.
        //                         La modification permet de corriger des informations ou de compléter des documents manquants.
        //                     </p>

        //                     <div className="mb-2 p-2 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaLayerGroup className="mr-2 text-blue-500" />
        //                             1. Accès à la modification
        //                         </h5>
        //                         <p className="mb-3 text-gray-700">
        //                             Pour modifier un enrôlement non terminé, suivez ces étapes depuis la liste des enrôlements :
        //                         </p>
        //                         <div className="grid grid-cols-1 gap-4 mb-3">
        //                             <div>
        //                                 <p className="mb-2 font-medium">Étape 1 : Localiser l'enrôlement</p>
        //                                 <p className="text-sm text-gray-700">
        //                                     Dans la liste des enrôlements, repérez la ligne correspondant au véhicule que vous souhaitez modifier.
        //                                     Les enrôlements non terminés sont généralement marqués d'un indicateur visuel (statut "En cours").
        //                                 </p>
        //                             </div>
        //                             <div>
        //                                 <p className="mb-2 font-medium">Étape 2 : Ouvrir le menu d'actions</p>
        //                                 <p className="text-sm text-gray-700">
        //                                     Cliquez sur les trois points (⋮) situés à la fin de la ligne.
        //                                     Cela ouvre un menu contextuel avec les options disponibles pour cet enrôlement.
        //                                 </p>
        //                                 <img
        //                                     src={enrolementActionsImg}
        //                                     alt="Menu d'actions d'enrôlement"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                             </div>
        //                             <div>
        //                                 <p className="mb-1 font-medium">Étape 3 : Sélectionner "Détails"</p>
        //                                 <p className="text-sm text-gray-700">
        //                                     Dans le menu qui apparaît, cliquez sur "Détails" pour accéder à la page de modification de l'enrôlement.
        //                                     Vous serez redirigé vers une interface similaire à celle du nouvel enrôlement, mais avec les champs pré-remplis.
        //                                 </p>
        //                             </div>
        //                         </div>
        //                     </div>

        //                     <div className="mb-2 p-2 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaEdit className="mr-2 text-purple-500" />
        //                             2. Interface de modification
        //                         </h5>
        //                         <p className="mb-3 text-gray-700">
        //                             L'interface de modification reprend la même structure que celle du nouvel enrôlement, avec quelques différences notables :
        //                         </p>
        //                         <ul className="list-disc pl-5 space-y-2 mb-4">
        //                             <li>Tous les champs sont pré-remplis avec les informations déjà enregistrées</li>
        //                             <li>Les documents déjà importés sont visibles dans la zone de prévisualisation</li>
        //                         </ul>
        //                         <img
        //                             src={enrolementTerminerImg}
        //                             alt="Interface de modification avec bouton Terminer"
        //                             className="img-fluid mb-2 border rounded-lg shadow-sm"
        //                         />
        //                     </div>

        //                     <div className="p-2 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaCheck className="mr-2 text-red-500" />
        //                             3. Finalisation de l'enrôlement
        //                         </h5>
        //                         <div className="grid grid-cols-1 gap-4">
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaCheckCircle className="mr-1 text-green-500" />
        //                                     Modification des informations
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Vous pouvez modifier n'importe quel champ comme lors de la création initiale :
        //                                 </p>
        //                                 <ul className="list-disc pl-5 text-sm space-y-1">
        //                                     <li>Corriger des informations erronées</li>
        //                                     <li>Ajouter des documents manquants</li>
        //                                     <li>Mettre à jour des dates d'expiration</li>
        //                                     <li>Changer des pièces jointes</li>
        //                                 </ul>
        //                             </div>
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaSave className="mr-1 text-blue-500" />
        //                                     Enregistrement et finalisation
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Une fois toutes les modifications effectuées :
        //                                 </p>
        //                                 <ol className="list-decimal pl-5 text-sm space-y-1">
        //                                     <li>Cliquez sur "Enregistrer" pour sauvegarder les changements sans terminer le processus</li>
        //                                     <li>Vérifiez que tous les onglets sont passés au vert (complets)</li>
        //                                     <li>Cliquez sur "Retour" pour aller à la liste et localiser l'enregistrement</li>
        //                                 </ol>
        //                                 <img
        //                                     src={enrolementActionsImg}
        //                                     alt="Interface de modification avec bouton Terminer"
        //                                     className="img-fluid mb-2 border rounded-lg shadow-sm"
        //                                 />
        //                                 <ol className="list-decimal pl-5 text-sm space-y-1">
        //                                     <li>Une fois localisé, cliquez sur les trois points de la ligne</li>
        //                                     <li>Et cliquez sur "Terminer" pour finaliser définitivement l'enrôlement</li>
        //                                     <li>Une interface de confirmation apparait pour valider</li>
        //                                 </ol>
        //                                 <img
        //                                     src={enrolementTerminerConfirmerImg}
        //                                     alt="Interface de modification avec bouton Terminer"
        //                                     className="img-fluid mb-2 border rounded-lg shadow-sm"
        //                                 />
        //                                 <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
        //                                     <FaInfoCircle className="inline mr-2 text-yellow-600" />
        //                                     Une fois terminé, l'enrôlement ne pourra plus être modifié directement. Pour apporter des modifications ultérieures,
        //                                     vous devrez passer par une procédure spécifique de mise à jour.
        //                                 </div>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //             )
        //         },
        //         {
        //             id: 'liste-enrolement',
        //             name: 'Liste des enrôlements',
        //             content: (
        //                 <div>
        //                     <h2 className="text-lg font-bold mb-2">Gestion de la liste des enrôlements</h2>
        //                     <p className="text-gray-700">
        //                         Cette interface vous permet de visualiser, rechercher et gérer tous les véhicules enrôlés dans le système.
        //                         Vous pouvez filtrer les résultats, modifier ou terminer un enrôlement en cours.
        //                     </p>

        //                     <div className="mb-2 p-2 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaLayerGroup className="mr-2 text-blue-500" />
        //                             1. Structure de la page
        //                         </h5>
        //                         <img
        //                             src={premierEnregistrementImg}
        //                             alt="Interface liste des enrôlements"
        //                             className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                         />
        //                         <p className="mb-3 text-gray-700">
        //                             La liste des enrôlements présente les informations principales sous forme de tableau avec :
        //                         </p>
        //                         <ul className="list-disc pl-5 space-y-2">
        //                             <li><strong>Barre de recherche</strong> : Permet de filtrer les résultats par immatriculation, propriétaire, etc.</li>
        //                             <li><strong>Pagination</strong> : Navigation entre les pages de résultats</li>
        //                             <li><strong>Colonnes triables</strong> : Cliquez sur les en-têtes pour trier par ordre croissant/décroissant</li>
        //                             <li><strong>Statut visuel</strong> : Indique si l'enrôlement est "En cours" ou "Terminé"</li>
        //                             <li><strong>Menu d'actions</strong> : Options disponibles pour chaque véhicule</li>
        //                         </ul>
        //                     </div>

        //                     <div className="mb-2 p-2 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaFileAlt className="mr-2 text-purple-500" />
        //                             2. Fonctionnalités clés
        //                         </h5>
        //                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaSearch className="mr-1 text-blue-500" />
        //                                     Recherche et filtrage
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Utilisez le champ de recherche en haut à droite pour trouver rapidement un véhicule par :
        //                                 </p>
        //                                 <ul className="list-disc pl-5 text-sm space-y-1">
        //                                     <li>Numéro d'immatriculation</li>
        //                                     <li>Nom du propriétaire</li>
        //                                     <li>Téléphone</li>
        //                                     <li>Référence de carte transport</li>
        //                                 </ul>
        //                                 <img
        //                                     src={enrolementRechercheImg}
        //                                     alt="Interface liste des enrôlements"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                             </div>
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaEllipsisV className="mr-1 text-green-600" />
        //                                     Actions disponibles
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Pour chaque véhicule, cliquez sur les trois points (⋮) pour accéder aux options :
        //                                 </p>
        //                                 <ul className="list-disc pl-5 text-sm space-y-1">
        //                                     <li><strong>Détails</strong> : Consulter toutes les informations</li>
        //                                     <li><strong>Supprimer</strong> : Mettre en corbeille l'enrôlement</li>
        //                                     <li><strong>Terminer</strong> : Finaliser un enrôlement en cours</li>
        //                                 </ul>
        //                                 <img
        //                                     src={enrolementActionsImg}
        //                                     alt="Interface liste des enrôlements actions"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                                 <p className="mb-3 text-gray-700">
        //                                     <strong>Terminer</strong> disparait lorsque l'enrolement est finalisé et que le statut passe à "enrôler"
        //                                 </p>
        //                                 <img
        //                                     src={enrolerActions2Img}
        //                                     alt="Interface liste des enrôlements actions"
        //                                     className="img-fluid mb-4 border rounded-lg shadow-sm"
        //                                 />
        //                             </div>
        //                         </div>
        //                     </div>

        //                     <div className="p-4 bg-gray-50 rounded-lg">
        //                         <h5 className="font-bold mb-3 flex items-center">
        //                             <FaTruck className="mr-2 text-red-500" />
        //                             3. Statuts et suite
        //                         </h5>
        //                         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaCheck className="mr-1 text-green-500" />
        //                                     Gestion des statuts
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Comprenez bien la signification des différents statuts :
        //                                 </p>
        //                                 <ul className="list-disc pl-5 text-sm space-y-1">
        //                                     <li><span className="text-blue-600 font-medium">En cours</span> : Enrôlement non finalisé, modifications possibles</li>
        //                                     <li><span className="text-green-600 font-medium">Enrôlé</span> : Processus terminé, visible dans le suivi documents</li>
        //                                 </ul>
        //                             </div>
        //                             <div>
        //                                 <h6 className="font-semibold flex items-center">
        //                                     <FaExclamation className="mr-1 text-yellow-500" />
        //                                     Info
        //                                 </h6>
        //                                 <p className="mb-3 text-gray-700">
        //                                     Une fois un enrôlement terminé :
        //                                 </p>
        //                                 <ol className="list-decimal pl-5 text-sm space-y-1">
        //                                     <li>Vous ne pouvez plus le modifier directement</li>
        //                                     <li>Il apparaîtra dans le module de suivi des documents</li>
        //                                     <li>Les échéances seront suivies automatiquement</li>
        //                                 </ol>
        //                             </div>
        //                         </div>
        //                     </div>
        //                 </div>
        //             )
        //         }
        //     ]
        // },
        {
            id: 'suivi-documents',
            name: 'Suivi Documents',
            icon: <FaFileAlt className="me-2" />,
            sections: [
                {
                    id: 'liste-vehicules-pieces',
                    name: 'Liste des pièces',
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Suivi des documents des véhicules</h2>
                            <p className="mb-1 text-gray-700">
                                Cette interface centrale vous permet de suivre l'état de validité de tous les documents obligatoires
                                pour chaque véhicule enrôlé. Le système met en évidence les documents expirés ou sur le point d'expirer
                                pour une gestion proactive des renouvellements.
                            </p>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Structure et fonctionnalités principales
                                </h5>
                                <img
                                    src={SuiviDocsImg}
                                    alt="Interface suivi des documents"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSearch className="mr-1 text-blue-500" />
                                            Outils de recherche
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li><strong>Recherche rapide</strong> : Par immatriculation, propriétaire ou téléphone</li>
                                            <img
                                                src={SuiviDocsRechercheImg}
                                                alt="Interface suivi des documents rechercher"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                            <li><strong className="mb-1">Recherche avancée</strong> : Filtres par période d'expiration, immatriculation, etc.</li>
                                            <img
                                                src={SuiviDocsRechercheAvanceeImg}
                                                alt="Interface suivi des documents recherche avancée"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                            <li><strong className="mb-1">Filtres temporels</strong> : Documents expirés, à 7/15/30 jours</li>
                                            <img
                                                src={SuiviDocsFiltreImg}
                                                alt="Interface suivi des documents filtre"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaInfoCircle className="mr-2 text-green-600" />
                                    2. Codes couleurs et statuts
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                    <div className="text-center">
                                        <span className="badge bg-primary">Valide</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le document est valide (plus de 30 jours avant expiration)
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-warning">30 jours</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le document expire dans moins de 30 jours (renouvellement nécessaire)
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-danger">Expiré</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Le document est expiré (renouvellement urgent requis)
                                        </p>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-700">
                                    Les couleurs s'affichent dynamiquement en fonction de la date du jour et des dates d'expiration enregistrées.
                                </p>
                            </div>

                            {/* <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaEllipsisV className="mr-2 text-red-500" />
                                    3. Actions disponibles
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSearch className="mr-1 text-green-600" />
                                            Consulter les pièces
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Pour consulter les versions actuelles des pièces d'un véhicules :
                                        </p>
                                        <ol className="list-decimal pl-5 text-sm space-y-1">
                                            <li>Cliquez sur les trois points (⋮) en fin de ligne</li>
                                            <li>Sélectionnez "Consulter" dans le menu</li>
                                            <li>Vous serez redirigé vers la page de consultation</li>
                                        </ol>
                                        <img
                                            src={SuiviDocsBtnConsulterImg}
                                            alt="Interface suivi des documents filtre"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaFileImport className="mr-1 text-blue-500" />
                                            Renouveler une pièces
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Pour renouveler une pièce expirée vous devez d'abord avoir au moins un document expiré au niveau de la ligne pour que cette option apparaisse :
                                        </p>
                                        <ol className="list-decimal pl-5 text-sm space-y-1">
                                            <li>Cliquez sur les trois points (⋮) en fin de ligne</li>
                                            <li>Sélectionnez "Renouveler" dans le menu </li>
                                            <li>Et vous serez redirigé sur la page de renouvellement des pièces</li>
                                        </ol>
                                        <img
                                            src={SuiviDocsBtnRenouvelerImg}
                                            alt="Interface suivi des documents filtre"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    )
                },
            ]
        },
        {
            id: 'gestion-tours',
            name: 'Mise en file',
            icon: <FaExchangeAlt className="me-2" />,
            sections: [
                {
                    id: 'tour-national',
                    name: 'Gestions des camions',
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Gestion des tours nationaux</h2>
                            <img
                                src={MenuToursNationauxImg}
                                alt="Menu tours nationaux"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Ce module permet de gérer les camions disponibles pour le transport national de marchandises.
                                Il suit le principe FIFO (First In, First Out) et permet d'organiser les camions en attente de chargement.
                            </p>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Interface principale
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    L'interface des tours nationaux se compose de deux onglets principaux :
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        <strong>Liste FIFO</strong> : Affiche les camions dans l'ordre d'arrivée (principe premier arrivé, premier servi) avec les informations complètes
                                        <img
                                            src={ToursNationauxListeImg}
                                            alt="Interface de tours nationaux"
                                            className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                                        />
                                    </li>
                                    <li>
                                        <strong>Liste de chargement</strong> : Montre les camions actuellement en cours de chargement avec leurs informations de fret
                                        <img
                                            src={ToursNationauxListeChargementImg}
                                            alt="Liste des camions en chargement"
                                            className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                                        />
                                    </li>
                                </ul>
                                <p className="mt-2 text-sm text-gray-700">
                                    Vous pouvez basculer entre ces deux vues à l'aide des onglets en haut de la page.
                                </p>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaFileAlt className="mr-2 text-purple-500" />
                                    2. Enregistrement d'un nouveau camion
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Pour ajouter un nouveau camion à la file d'attente :
                                </p>
                                <ol className="list-decimal pl-5 space-y-1 mb-2">
                                    <li>Cliquez sur le bouton "Enregistrer" dans l'onglet Liste FIFO</li>
                                    <li>Remplissez le formulaire avec les informations requises :
                                        <ul className="list-disc pl-5 mt-1">
                                            <li>Sélectionnez le genre de véhicule (Articulé ou Non articulé)</li>
                                            <li>Choisissez la tête et la queue pour les véhicules articulés</li>
                                            <li>Sélectionnez l'immatriculation pour les véhicules non articulés</li>
                                            <li>Indiquez le conducteur assigné</li>
                                            <li>Spécifiez le parc de stationnement</li>
                                            <li>Entrez la charge utile du véhicule</li>
                                        </ul>
                                    </li>
                                    <img
                                        src={ToursNationauxNouveauImg}
                                        alt="Formulaire d'enregistrement"
                                        className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                    />
                                    <li>Cliquez sur "Prévisualiser" pour vérifier les informations</li>
                                    <li>Confirmez l'enregistrement</li>
                                </ol>
                                <div className="mt-2 p-2 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    La charge utile est automatiquement remplie à partir des informations de la carte grise du véhicule.
                                </div>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaSearch className="mr-2 text-green-600" />
                                    3. Gestion des statuts
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Les camions peuvent avoir différents statuts :
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                                    <div className="text-center">
                                        <span className="badge badge-secondary">Disponible</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Camion enregistré et prêt pour le transport
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-warning">En panne</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Camion temporairement hors service
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-success">Chargement</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Camion en cours de chargement
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-primary">Sorti</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Camion parti avec sa marchandise
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-danger">Sorti de rang</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Conducteur temporairement indisponible
                                        </p>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-700">
                                    Vous pouvez changer le statut d'un camion via le menu d'actions (trois points).
                                </p>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaMoneyBill className="mr-2 text-red-500" />
                                    4. Gestion des paiements
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Le système permet de gérer les droits de tour et de chargement :
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                    <div className="text-center">
                                        <span className="badge badge-secondary">Non payé</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Droit de tour non réglé
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-success">Payé</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Droit de tour réglé
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-secondary">Non payé</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Droit de chargement non réglé
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-success">Payé</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Droit de chargement réglé
                                        </p>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-700">
                                    Ces statuts peuvent être modifiés via le menu d'actions (trois points).
                                </p>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaEllipsisV className="mr-2 text-red-500" />
                                    5. Actions disponibles
                                </h5>
                                <img
                                    src={ToursNationauxActionsImg}
                                    alt="Menu des actions"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaExchangeAlt className="mr-1 text-green-500" />
                                            Changer statut
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Permet de faire passer un camion d'un statut à un autre selon le workflow.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSignOutAlt className="mr-1 text-blue-500" />
                                            Sortir de rang
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Retire temporairement un camion de la file d'attente.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaCheckCircle className="mr-1 text-green-500" />
                                            Gérer paiements
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Marquer les droits de tour/chargement comme payés ou non payés.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaEye className="mr-1 text-orange-500" />
                                            Voir lettre
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Prévisualiser la lettre de voiture associée au camion.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaOutdent className="mr-1 text-primary" />
                                            Sortir
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Marquer un camion comme étant parti avec sa marchandise.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaTrash className="mr-1 text-red-500" />
                                            Supprimer
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Retire définitivement un camion de la file d'attente.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaOutdent className="mr-2 text-primary" />
                                    6. Processus de sortie
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Pour faire sortir un camion :
                                </p>
                                <ol className="list-decimal pl-5 space-y-1 mb-2">
                                    <li>Sélectionnez "Sortir" dans le menu d'actions</li>
                                    <li>Importez la lettre de voiture (format PDF ou image)</li>
                                    <li>Confirmez la sortie</li>
                                </ol>
                                <div className="mt-2 p-2 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    Le droit de chargement doit être marqué comme "Payé" avant de pouvoir sortir un camion.
                                </div>
                            </div>

                            <div className="p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaDesktop className="mr-2 text-red-500" />
                                    7. Écrans d'affichage
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    TransportPro propose des écrans dédiés pour visualiser les camions :
                                </p>
                                <ul className="list-disc pl-5 mb-3">
                                    <li>Écran principal des tours nationaux</li>
                                </ul>
                                <p className="text-sm text-gray-700">
                                    L'écran s'ouvre dans un nouvel onglet via le bouton en haut de la page de gestion.
                                </p>
                                <img
                                    src={ToursNationauxEcranImg}
                                    alt="Écran d'affichage"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                            </div>
                        </div>
                    )
                },
                {
                    id: 'tour-international',
                    name: 'Fret en transit',
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Gestion des tours internationaux</h2>
                            <img
                                src={MenuToursInternationauxImg}
                                alt="Menu tours internationaux"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Ce module permet de gérer les camions effectuant des transports transfrontaliers.
                                Il suit le même principe FIFO que les tours nationaux mais avec des spécificités
                                liées aux documents et procédures douanières internationales.
                            </p>

                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Interface principale
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    L'interface des tours internationaux présente deux onglets principaux :
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        <strong>Liste FIFO</strong> : Affiche les camions dans l'ordre d'arrivée avec leurs informations complètes
                                        <img
                                            src={ToursInternationauxListeImg}
                                            alt="Interface de tours internationaux"
                                            className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                                        />
                                    </li>
                                    <li>
                                        <strong>Liste de chargement</strong> : Montre les camions actuellement en cours de chargement avec leurs informations de fret
                                        <img
                                            src={ToursInternationauxListeChargementImg}
                                            alt="Liste des camions en chargement"
                                            className="img-fluid mt-1 mb-4 border rounded-lg shadow-sm"
                                        />
                                    </li>
                                </ul>
                                <p className="mt-3 text-sm text-gray-700">
                                    Vous pouvez basculer entre ces deux vues à l'aide des onglets en haut de la page.
                                </p>
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaFileAlt className="mr-2 text-purple-500" />
                                    2. Enregistrement d'un nouveau camion
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Pour ajouter un nouveau camion international à la file d'attente :
                                </p>
                                <ol className="list-decimal pl-5 space-y-1 mb-4">
                                    <li>Cliquez sur le bouton "Enregistrer" dans l'onglet Liste FIFO</li>
                                    <li>Remplissez le formulaire avec les informations requises :
                                        <ul className="list-disc pl-5 mt-1">
                                            <li>Sélectionnez le genre de véhicule (Articulé ou Non articulé)</li>
                                            <li>Choisissez la tête et la queue pour les véhicules articulés</li>
                                            <li>Sélectionnez l'immatriculation pour les véhicules non articulés</li>
                                            <li>Indiquez le conducteur assigné</li>
                                            <li>Spécifiez le parc de stationnement (doit être de type "international")</li>
                                            <li>Entrez la charge utile du véhicule</li>
                                        </ul>
                                    </li>
                                    <img
                                        src={ToursInternationauxNouveauImg}
                                        alt="Formulaire d'enregistrement"
                                        className="img-fluid mb-4 border rounded-lg shadow-sm"
                                    />
                                    <li>Cliquez sur "Prévisualiser" pour vérifier les informations</li>
                                    <li>Confirmez l'enregistrement</li>
                                </ol>
                                <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    Les camions internationaux doivent obligatoirement être affectés à un parc de type "international".
                                </div>
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaSearch className="mr-2 text-green-600" />
                                    3. Gestion des statuts
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Les camions internationaux peuvent avoir différents statuts :
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-4">
                                    <div className="text-center">
                                        <span className="badge badge-secondary">Disponible</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Camion enregistré et prêt pour le transport international
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-warning">En panne</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Camion temporairement hors service
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-success">Chargement</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Camion en cours de chargement pour l'export
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-primary">Sorti</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Camion parti avec sa marchandise vers l'étranger
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge bg-danger">Sorti de rang</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Conducteur temporairement indisponible
                                        </p>
                                    </div>
                                </div>
                                <p className="text-sm text-gray-700">
                                    Vous pouvez changer le statut d'un camion via le menu d'actions (trois points).
                                </p>
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaShieldAlt className="mr-2 text-red-500" />
                                    4. Gestion des documents et paiements
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Le système permet de gérer les documents et paiements spécifiques aux transports internationaux :
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                    <div className="text-center">
                                        <span className="badge badge-secondary">Non payé</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Droit de tour non réglé
                                        </p>
                                    </div>
                                    <div className="text-center">
                                        <span className="badge badge-success">Payé</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Droit de tour réglé
                                        </p>
                                    </div>
                                    {/* <div className="text-center">
                                        <span className="badge badge-secondary">Documents manquants</span>
                                        <p className="text-sm mt-2 text-gray-700">
                                            Documents douaniers incomplets
                                        </p>
                                    </div> */}
                                </div>
                                <p className="text-sm text-gray-700">
                                    Ces statuts peuvent être modifiés via le menu d'actions (trois points).
                                </p>
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaEllipsisV className="mr-2 text-red-500" />
                                    5. Actions disponibles
                                </h5>
                                <img
                                    src={ToursInternationauxActionsImg}
                                    alt="Menu des actions"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaExchangeAlt className="mr-1 text-green-500" />
                                            Changer statut
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Permet de faire passer un camion d'un statut à un autre selon le workflow international.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSignOutAlt className="mr-1 text-blue-500" />
                                            Sortir de rang
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Retire temporairement un camion de la file d'attente internationale.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaCheckCircle className="mr-1 text-green-500" />
                                            Gérer paiements
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Marquer les droits de tour comme payés ou non payés.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaEye className="mr-1 text-orange-500" />
                                            Voir lettre
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Prévisualiser la lettre de voiture internationale associée au camion.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaOutdent className="mr-1 text-primary" />
                                            Sortir
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Marquer un camion comme étant parti avec sa marchandise vers l'étranger.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaTrash className="mr-1 text-red-500" />
                                            Supprimer
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Retire définitivement un camion de la file d'attente internationale.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaOutdent className="mr-2 text-primary" />
                                    6. Processus de sortie internationale
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Pour faire sortir un camion international :
                                </p>
                                <ol className="list-decimal pl-5 space-y-1 mb-4">
                                    <li>Sélectionnez "Sortir" dans le menu d'actions</li>
                                    <li>Importez la lettre de voiture internationale (format PDF ou image)</li>
                                    <li>Vérifiez que tous les documents douaniers sont en règle</li>
                                    <li>Confirmez la sortie</li>
                                </ol>
                                <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    Le droit de chargement doit être marqué comme "Payé" avant de pouvoir sortir un camion international.
                                </div>
                            </div>

                            <div className="p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaDesktop className="mr-2 text-red-500" />
                                    7. Écrans d'affichage spécifiques
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    TransportPro propose des écrans dédiés pour visualiser les camions internationaux :
                                </p>
                                <ul className="list-disc pl-5 mb-3">
                                    <li>Écran principal des tours internationaux</li>
                                    <li>Écran par pays de destination</li>
                                </ul>
                                <p className="text-sm text-gray-700">
                                    Ces écrans s'ouvrent dans un nouvel onglet via le bouton "Ecran" en haut de la page de gestion.
                                </p>
                                <img
                                    src={ToursInternationauxEcranImg}
                                    alt="Écran d'affichage international"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                            </div>

                            <div className="p-4 bg-gray-50 rounded-lg mt-4">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaGlobe className="mr-2 text-blue-500" />
                                    8. Spécificités internationales
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Les fonctionnalités spécifiques aux transports internationaux incluent :
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>Gestion des documents douaniers</li>
                                    <li>Suivi par pays de destination</li>
                                    <li>Vérification des documents obligatoires avant sortie</li>
                                    <li>Statistiques spécifiques aux flux internationaux</li>
                                </ul>
                                <div className="mt-3 p-3 bg-blue-50 border-l-4 border-blue-400">
                                    <FaInfoCircle className="inline mr-2 text-blue-600" />
                                    Les camions internationaux sont visibles dans un écran dédié organisé par pays de destination.
                                </div>
                            </div>
                        </div>
                    )
                },
                {
                    id: 'gestion-frets',
                    name: 'Gestion des frets',
                    content: (
                        <div className="space-y-6">
                            <h2 className="text-2xl font-bold text-blue-800 mb-4">Gestion des Déclarations de Fret</h2>
                            <img
                                src={MenuToursFretImg}
                                alt="Menu principal de gestion des frets"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Ce module permet d'enregistrer et de suivre les marchandises transportées lors des tours nationaux et internationaux.
                                Il comprend quatre interfaces principales avec des fonctionnalités complètes pour gérer le cycle de vie des déclarations.
                            </p>

                            {/* Section 1: Liste des Déclarations */}
                            <div>
                                <h5 className="font-bold text-xl mb-4 flex items-center text-blue-700">
                                    <FaLayerGroup className="mr-3 text-blue-500" />
                                    1. Interface Liste des Déclarations
                                </h5>
                                <img
                                    src={ToursFretListeImg}
                                    alt="Liste des déclarations de fret"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
                                    <div>
                                        <h6 className="font-semibold mb-2 flex items-center">
                                            <FaSearch className="mr-2 text-blue-500" />
                                            Fonctionnalités Principales
                                        </h6>
                                        <ul className="list-disc pl-5 space-y-2 text-gray-700">
                                            <li><strong>Recherche avancée</strong> : Filtrage par tous les champs du tableau</li>
                                            <li><strong>Tri des colonnes</strong> : Cliquez sur les en-têtes pour trier</li>
                                            <li><strong>Vue responsive</strong> : Adapté pour mobile et desktop</li>
                                            <li><strong>Visualisation des statuts</strong> :
                                                <ul className="list-disc pl-5 mt-1 space-y-1">
                                                    <li><span className="badge badge-secondary">En attente réservation</span> : Statut 'en attente' - Non réservé</li>
                                                    <li><span className="badge badge-warning">En attente assignation</span> : Statut 'reservee' - Réservé mais non assigné</li>
                                                    <li><span className="badge bg-success">Assignation en cours</span> : Statut 'En cours' - Assignation partielle</li>
                                                    <li><span className="badge bg-primary">Assignation terminée</span> : Statut 'selection terminee' - Tous camions assignés</li>
                                                </ul>
                                            </li>
                                            <li className="mt-1"><strong>Calcul des quotas restants</strong> : Affichage du nombre de camions manquants en cliquant sur l'option "Détails" dans les actions.</li>
                                            <img
                                                src={ToursFretQuotasImg}
                                                alt="Liste des déclarations de fret"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                        </ul>
                                    </div>

                                    <div>
                                        <h6 className="font-semibold mb-2 flex items-center">
                                            <FaEllipsisV className="mr-2 text-green-600" />
                                            Actions Disponibles
                                        </h6>
                                        <div className="space-y-3">
                                            <div className="p-1 bg-white rounded">
                                                <div className="font-medium flex items-center">
                                                    <FaEdit className="mr-2 text-primary" />
                                                    Modifier
                                                </div>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    Pour frets avec statut 'en attente' seulement
                                                </p>
                                            </div>

                                            <div className="p-1 bg-white rounded">
                                                <div className="font-medium flex items-center">
                                                    <FaSearch className="mr-2 text-info" />
                                                    Détails complets
                                                </div>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    Affiche quotas et liste des camions assignés
                                                </p>
                                            </div>

                                            <div className="p-1 bg-white rounded">
                                                <div className="font-medium flex items-center">
                                                    <FaTrash className="mr-2 text-danger" />
                                                    Supprimer
                                                </div>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    Pour frets 'en attente' seulement (action irréversible)
                                                </p>
                                            </div>

                                            <div className="p-1 bg-white rounded">
                                                <div className="font-medium flex items-center">
                                                    <FaCogs className="mr-2 text-secondary" />
                                                    Réservation de transport
                                                </div>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    Spécifier types et nombres de camions nécessaires
                                                </p>
                                            </div>

                                            <div className="p-1 bg-white rounded">
                                                <div className="font-medium flex items-center">
                                                    <FaTruck className="mr-2 text-dark" />
                                                    Assigner
                                                </div>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    Assignation automatique des camions disponibles
                                                </p>
                                            </div>
                                        </div>
                                        <img
                                            src={ToursFretActionsImg}
                                            alt="Menu des actions disponibles"
                                            className="img-fluid mt-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Section 2: Nouvelle Déclaration */}
                            <div className="">
                                <h5 className="font-bold text-xl mb-4 flex items-center text-green-700">
                                    <FaPlusCircle className="mr-3 text-green-600" />
                                    2. Création d'une Nouvelle Déclaration
                                </h5>
                                <img
                                    src={ToursFretNouveauImg}
                                    alt="Formulaire de création de fret"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <h6 className="font-semibold mb-2">Champs obligatoires</h6>
                                        <ul className="list-disc pl-5 space-y-2 text-gray-700">
                                            <li><strong>Référence</strong> : Code unique du fret</li>
                                            <li><strong>Type de fret</strong> : National ou International</li>
                                            <li><strong>Bailleur</strong> : Client demandeur</li>
                                            <li><strong>Destinataire</strong> : Client final</li>
                                            <li><strong>Trajet</strong> : Villes de départ et arrivée</li>
                                            <li><strong>Dates</strong> : Période de transport</li>
                                            <li><strong>Nature marchandise</strong> : Type de cargaison</li>
                                        </ul>
                                    </div>

                                    <div className="mb-3 p-2 bg-yellow-50 border-l-4 border-yellow-400 rounded">
                                        <FaExclamationTriangle className="inline mr-2 text-yellow-500" />
                                        Le statut initial est 'en attente'. Une réservation est nécessaire avant toute assignation.
                                    </div>
                                </div>
                            </div>

                            {/* Section 3: Réservation de Transport */}
                            <div className="">
                                <h5 className="font-bold text-xl mb-4 flex items-center text-purple-700">
                                    <FaCogs className="mr-3 text-purple-500" />
                                    3. Réservation de Transport
                                </h5>
                                <img
                                    src={ToursFretModifierImg}
                                    alt="Interface de réservation"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <h6 className="font-semibold mb-3">Processus en 2 étapes</h6>
                                        <ol className="list-decimal pl-5 space-y-3">
                                            <li>
                                                <strong>Spécificités</strong>
                                                <ul className="list-disc pl-5 mt-1 text-sm text-gray-600 space-y-1">
                                                    <li>Sélection des types de camions</li>
                                                    <li>Définition du nombre de camions par type</li>
                                                    <li>Spécification de la charge utile par camion</li>
                                                </ul>
                                            </li>
                                            <li>
                                                <strong>Quotas (frets internationaux)</strong>
                                                <ul className="list-disc pl-5 mt-1 text-sm text-gray-600 space-y-1">
                                                    <li>Répartition par source (nationaux/internationaux)</li>
                                                    <li>Vérification de la cohérence des quotas</li>
                                                </ul>
                                            </li>
                                        </ol>
                                    </div>

                                    <div>
                                        <h6 className="font-semibold mb-3">Règles de validation</h6>
                                        <ul className="list-disc pl-5 space-y-1 text-gray-700">
                                            <li>Charge utile -- 0 pour tous les types</li>
                                            <li>Nombre de camions -- 0 pour chaque type</li>
                                            <li>Pour les frets internationaux : somme des quotas = nombre total</li>
                                            <li>Modification possible avant toute assignation</li>
                                        </ul>

                                        <div className="mb-3 bg-blue-50 border-l-4 border-blue-400 rounded">
                                            <FaInfoCircle className="inline mr-2 text-blue-500" />
                                            <strong>Automatisation :</strong> Le système tente d'assigner automatiquement les camions après réservation.
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Section 4: Modification */}
                            <div className="">
                                <h5 className="font-bold text-xl mb-4 flex items-center text-orange-700">
                                    <FaEdit className="mr-3 text-orange-500" />
                                    4. Modification d'une Déclaration
                                </h5>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div>
                                        <h6 className="font-semibold mb-1">Conditions</h6>
                                        <ul className="list-disc pl-5 space-y-2 text-gray-700">
                                            <li>Statut doit être 'en attente' pour modifier les informations de base</li>
                                            <li>Réservation modifiable avant toute assignation</li>
                                            <li>Certains champs verrouillés après validation</li>
                                            <li>Modification des quotas possible si statut 'reservee'</li>
                                        </ul>
                                    </div>

                                    <div>
                                        <h6 className="font-semibold mb-1">Processus</h6>
                                        <ol className="list-decimal pl-5 space-y-2 text-gray-700">
                                            <li>Localiser le fret dans la liste</li>
                                            <li>Cliquer sur "⋮" puis "Modifier"</li>
                                            <li>Apporter les modifications nécessaires</li>
                                            <li>Valider les changements</li>
                                        </ol>
                                    </div>
                                </div>

                                <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="p-3 bg-red-50 border-l-4 border-red-400 rounded">
                                        <FaExclamationCircle className="inline mr-2 text-red-500" />
                                        Toute modification après assignation peut nécessiter une réassignation des camions.
                                    </div>
                                    <div className="p-3 bg-green-50 border-l-4 border-green-400 rounded">
                                        <FaInfoCircle className="inline mr-2 text-green-500" />
                                        <strong>Visualisation :</strong> Les quotas restants se mettent à jour immédiatement après modification.
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                },
                {
                    id: 'paiement',
                    name: 'Historique de paiement',
                    content: (
                        <div className="space-y-6">
                            <h2 className="text-2xl font-bold text-blue-800 mb-4">Historique de paiements</h2>
                            <img
                                src={MenuToursPaiementImg}
                                alt="Menu principal de gestion des frets"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Gestion
                            </p>
                        </div>
                    )
                }
            ]
        },
        {
            id: 'administration',
            name: 'Administration',
            icon: <FaCogs className="me-2" />,
            sections: [
                {
                    id: 'groupes',
                    name: 'Gestion des groupes',
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Gestion des groupes d'utilisateurs</h2>
                            <img
                                src={AdminMenuGroupes}
                                alt="Menu admin"
                                className="img-fluid mb-2 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Cette section permet de créer, configurer et gérer les groupes d'utilisateurs qui déterminent les droits d'accès aux différentes fonctionnalités de l'application.
                            </p>

                            {/* Partie existante sur la liste des groupes */}
                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Interface principale
                                </h5>
                                <img
                                    src={GroupesListe}
                                    alt="Interface Groupes"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                                <p className="mb-1 text-gray-700">
                                    La liste des groupes affiche les informations suivantes :
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li><strong>Titre</strong> : Nom du groupe</li>
                                    <li><strong>Description</strong> : Détails sur l'usage du groupe</li>
                                    <li><strong>Membres</strong> : Nombre d'utilisateurs dans le groupe</li>
                                </ul>
                                <div className="mt-1 mb-3 p-1 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    Sélectionnez un groupe en cliquant sur sa ligne pour activer les boutons d'action.
                                </div>
                                <img
                                    src={GroupesListeSelection}
                                    alt="Interface Groupes"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                            </div>

                            {/* Partie existante sur la création */}
                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaPlus className="mr-2 text-green-600" />
                                    2. Création d'un nouveau groupe
                                </h5>
                                <p className="mb-1 text-gray-700">
                                    Pour ajouter un nouveau groupe :
                                </p>
                                <ol className="list-decimal pl-5 space-y-1 mb-4">
                                    <li>Cliquez sur le bouton "Ajouter"</li>
                                    <li>Remplissez le formulaire :
                                        <ul className="list-disc pl-5 mt-1 mb-2">
                                            <li><strong>Titre</strong> : Nom unique du groupe (obligatoire)</li>
                                            <li><strong>Description</strong> : Détails sur l'usage du groupe</li>
                                            <li><strong>Type</strong> : "Cohorte" ou "Groupe système"</li>
                                        </ul>
                                        <img
                                            src={GroupesAjouter}
                                            alt="Interface Groupes"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </li>
                                    <li>Validez en cliquant sur "Ajouter"</li>
                                </ol>
                            </div>

                            {/* Nouvelle partie détaillée sur la configuration */}
                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaCogs className="mr-2 text-purple-500" />
                                    3. Configuration avancée des groupes
                                </h5>
                                <p className="mb-2 text-gray-700">
                                    Après avoir sélectionné un groupe dans la liste principale, cliquez sur le bouton "Configurer" pour accéder à l'interface complète de paramétrage. Cette interface se compose de trois onglets fondamentaux permettant une gestion granulaire des permissions et membres.
                                </p>
                                <img
                                    src={GroupesListeSelectionConfigurer}
                                    alt="Interface Groupes"
                                    className="img-fluid mb-2 border rounded-lg shadow-sm"
                                />

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-2">
                                    {/* Colonne Infos */}
                                    <div className="p-3 rounded-lg">
                                        <h6 className="font-semibold flex items-center mb-2">
                                            <FaUserShield className="mr-2 text-blue-400" />
                                            Informations générales
                                        </h6>
                                        <p className="text-sm mb-2">
                                            Cet onglet permet de modifier les propriétés de base du groupe :
                                        </p>
                                        <img
                                            src={GroupesConfigurerInfos}
                                            alt="Interface Groupes configuration"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li><strong>Titre</strong> : Le nom identifiant du groupe (modifiable à tout moment)</li>
                                            <li><strong>Description</strong> : Champ textuel pour préciser la vocation du groupe</li>
                                            <li><strong>Type</strong> :
                                                <ul className="list-disc pl-5 mt-1">
                                                    <li><em>Cohorte</em> : Groupe standard pour les utilisateurs</li>
                                                    <li><em>Groupe système</em> : Pour les accès administratifs (à utiliser avec précaution)</li>
                                                </ul>
                                            </li>
                                        </ul>
                                        <p className="text-xs mt-2 text-gray-600">
                                            Toute modification nécessite un clic sur le bouton "Enregistrer" pour être prise en compte.
                                        </p>
                                    </div>

                                    {/* Colonne Accès */}
                                    <div className="p-3 rounded-lg">
                                        <h6 className="font-semibold flex items-center mb-2">
                                            <FaUniversalAccess className="mr-2 text-green-500" />
                                            Gestion des permissions
                                        </h6>
                                        <p className="text-sm mb-2">
                                            L'onglet Accès permet de définir précisément les droits applicables à tous les membres du groupe :
                                        </p>
                                        <img
                                            src={GroupesConfigurerAcces}
                                            alt="Interface Groupes configuration"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />

                                        <div className="text-sm">
                                            <p className="font-medium mb-1">Fonctionnalités métiers :</p>
                                            <ul className="list-disc pl-5 space-y-1">
                                                <li><strong>Enrôlement</strong> : Accès au module d'enregistrement des véhicules</li>
                                                <li><strong>Suivi documents</strong> : Gestion des pièces administratives</li>
                                                <li><strong>Gestion des tours</strong> : Planification des tournées nationales/internationales</li>
                                            </ul>

                                            <p className="font-medium mt-2 mb-1">Privilèges administratifs :</p>
                                            <ul className="list-disc pl-5 space-y-1">
                                                <li><strong>Utilisateurs/Groupes</strong> : Gestion des comptes et permissions</li>
                                                <li><strong>Paramètres système</strong> : Configuration avancée de l'application</li>
                                                <li><strong>Journalisation</strong> : Consultation des historiques d'activité</li>
                                            </ul>
                                        </div>
                                        <p className="text-xs mt-2 text-gray-600">
                                            Cochez uniquement les cases correspondant aux droits strictement nécessaires.
                                        </p>
                                    </div>

                                    {/* Colonne Membres */}
                                    <div className="p-3 rounded-lg">
                                        <h6 className="font-semibold flex items-center mb-2">
                                            <FaUsers className="mr-2 text-orange-500" />
                                            Administration des membres
                                        </h6>
                                        <p className="text-sm mb-2">
                                            Interface complète pour gérer la composition du groupe avec :
                                        </p>
                                        <img
                                            src={GroupesConfigurerMembres}
                                            alt="Interface Groupes configuration"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li><strong>Ajout/retrait</strong> : Transfert individualisé des utilisateurs entre les listes</li>
                                            <li><strong>Sélection multiple</strong> : Ctrl+clic ou Shift+clic ou glissement clic maintenu  pour opérations groupées</li>
                                            <li><strong>Recherche</strong> : Filtrage par nom/prénom/email</li>
                                            <li><strong>Transfert par lot</strong> : Boutons "Tous" pour déplacer l'ensemble</li>
                                        </ul>
                                        <div className="mt-2 p-2 bg-gray-100 rounded text-xs">
                                            <FaInfoCircle className="inline mr-1 text-gray-600" />
                                            <strong>Important</strong> : Les modifications ne sont effectives qu'après validation via le bouton "Enregistrer" en bas de page.
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-1 p-3 bg-blue-50 border-l-4 border-blue-400 rounded">
                                    <div className="flex items-start">
                                        {/* <FaInfoCircle className="flex-shrink-0 mt-1 mr-2 text-blue-500" /> */}
                                        <strong className="block mb-1">Workflow recommandé :</strong>
                                        <ol className="list-decimal pl-5 space-y-1">
                                            <li><strong>Création</strong> : Définir le titre et la description du groupe</li>
                                            <li><strong>Permissions</strong> : Configurer précisément les droits avant d'ajouter des membres</li>
                                            <li><strong>Composition</strong> : Ajouter les utilisateurs seulement après avoir paramétré les accès</li>
                                        </ol>
                                        <p className="mt-2 text-sm">
                                            Cette méthode évite d'accorder temporairement des droits trop permissifs.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Partie existante sur la suppression */}
                            <div className="p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-2 flex items-center">
                                    <FaTrash className="mr-2 text-red-500" />
                                    4. Suppression d'un groupe
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaExclamationTriangle className="mr-1 text-warning" />
                                            Conditions
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Un groupe ne peut être supprimé que si :
                                        </p>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Aucun utilisateur n'y est affecté</li>
                                            <li>Il ne s'agit pas d'un groupe système</li>
                                        </ul>
                                    </div>
                                    <div>
                                        <img
                                            src={GroupesListeSelectionSupprimer}
                                            alt="Interface Groupes configuration"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                        <h6 className="font-semibold flex items-center">
                                            <FaCheckCircle className="mr-1 text-green-500" />
                                            Procédure
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Pour supprimer un groupe :
                                        </p>
                                        <ol className="list-decimal pl-5 text-sm space-y-1">
                                            <li>Sélectionnez le groupe dans la liste</li>
                                            <li>Cliquez sur "Supprimer"</li>
                                            <li>Confirmez dans la boîte de dialogue</li>
                                        </ol>
                                        <img
                                            src={GroupesSupprimer}
                                            alt="Interface Groupes configuration"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                },
                {
                    id: 'utilisateurs',
                    name: 'Gestion des utilisateurs',
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Gestion des comptes utilisateurs</h2>
                            <img
                                src={AdminMenuUtilisateurs} UtilisateursListe
                                alt="Menu administration utilisateurs"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Cette interface permet aux administrateurs de gérer l'ensemble des comptes utilisateurs de l'application TransportPro.
                                Vous pouvez activer/désactiver des comptes, supprimer des utilisateurs et consulter les informations de base.
                            </p>

                            {/* Section 1: Interface principale */}
                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Structure de la page
                                </h5>
                                <img
                                    src={UtilisateursListe}
                                    alt="administration utilisateurs"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                                <p className="mb-3 text-gray-700">
                                    La liste des utilisateurs présente les informations essentielles sous forme de tableau :
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li><strong>Nom et prénoms</strong> : Identité complète de l'utilisateur</li>
                                    <li><strong>Email</strong> : Adresse email utilisée pour la connexion</li>
                                    <li><strong>Téléphone</strong> : Numéro de contact</li>
                                    <li><strong>Statut</strong> : Indique si le compte est actif ou désactivé</li>
                                </ul>

                                <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    Sélectionnez un utilisateur en cliquant sur sa ligne pour activer les boutons d'action.
                                </div>
                                <img
                                    src={UtilisateursListeSelection}
                                    alt="administration utilisateurs"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                            </div>

                            {/* Section 2: Actions disponibles */}
                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaEllipsisV className="mr-2 text-red-500" />
                                    2. Fonctionnalités principales
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaCheck className="mr-1 text-green-500" />
                                            Activation/Désactivation
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Permet de :
                                        </p>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Désactiver temporairement un compte sans le supprimer</li>
                                            <li>Réactiver un compte précédemment désactivé</li>
                                            <li>Empêcher la connexion d'un utilisateur problématique</li>
                                        </ul>
                                        <div className="mt-3 p-2 bg-blue-50 rounded text-xs">
                                            <FaInfoCircle className="inline mr-1 text-blue-500" />
                                            Un compte désactivé conserve toutes ses données mais ne peut plus se connecter.
                                        </div>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaTrash className="mr-1 text-red-500" />
                                            Suppression définitive
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Cette action :
                                        </p>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Supprime irréversiblement le compte utilisateur</li>
                                            <li>Nécessite une confirmation explicite</li>
                                            <li>Est réservée aux cas extrêmes (départ, doublon...)</li>
                                        </ul>
                                        {/* <div className="mt-3 p-2 bg-red-50 rounded text-xs">
                                            <FaExclamationTriangle className="inline mr-1 text-red-500" />
                                            Attention : Cette action est irréversible et supprime toutes les données associées.
                                        </div> */}
                                    </div>
                                </div>
                            </div>

                            {/* Section 3: Bonnes pratiques */}
                            {/* <div className="p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaShieldAlt className="mr-2 text-red-500" />
                                    3. Recommandations de sécurité
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaUserShield className="mr-1 text-primary" />
                                            Gestion des comptes
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Privilégiez la désactivation à la suppression</li>
                                            <li>Vérifiez deux fois avant de supprimer un compte</li>
                                            <li>Documentez les raisons des désactivations/suppressions</li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaExclamationTriangle className="mr-1 text-warning" />
                                            Précautions
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Ne partagez jamais les informations de connexion</li>
                                            <li>Limitez l'accès à cette interface aux seuls administrateurs</li>
                                            <li>Auditez régulièrement la liste des comptes actifs</li>
                                        </ul>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    )
                },
                {
                    id: 'admin-enrolements',
                    name: 'Administration des enrôlements',
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Administration des enrôlements</h2>
                            <img
                                src={AdminMenuEnrolements}
                                alt="Menu administration des enrôlements"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Cette interface permet aux administrateurs de gérer l'ensemble des véhicules enrôlés dans le système.
                                Vous pouvez consulter, modifier ou archiver les enrôlements existants.
                            </p>

                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Interface principale
                                </h5>
                                <img
                                    src={AdminEnrolementsListe}
                                    alt="Interface administration des enrôlements"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                                <p className="mb-3 text-gray-700">
                                    La liste des enrôlements présente les informations essentielles :
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li><strong>Immatriculation</strong> : Numéro d'immatriculation du véhicule</li>
                                    <li><strong>Nationalité</strong> : Pays d'origine du véhicule</li>
                                    <li><strong>Type de véhicule</strong> : Catégorie du véhicule</li>
                                    <li><strong>Propriétaire</strong> : Nom du propriétaire</li>
                                    <li><strong>Téléphone</strong> : Contact du propriétaire</li>
                                    <li><strong>Carte transport</strong> : Référence de la carte</li>
                                    <li><strong>Date expiration</strong> : Validité de la carte transport</li>
                                    <li><strong>Ajouté par</strong> : Utilisateur ayant créé l'enrôlement</li>
                                </ul>
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaSearch className="mr-2 text-green-600" />
                                    2. Recherche et filtrage
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Vous pouvez filtrer les enrôlements grâce à :
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSearch className="mr-1 text-blue-500" />
                                            Champ de recherche
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Recherchez par immatriculation, propriétaire, téléphone ou référence de carte.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaFilter className="mr-1 text-purple-500" />
                                            Pagination
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Choisissez le nombre d'éléments à afficher par page (10, 20 ou 50).
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaEllipsisV className="mr-2 text-red-500" />
                                    3. Actions disponibles
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaEdit className="mr-1 text-primary" />
                                            Modifier
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Permet de corriger les informations d'un enrôlement existant.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaTrash className="mr-1 text-danger" />
                                            Mettre en corbeille
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Archive un enrôlement (réversible par un administrateur).
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaCheck className="mr-1 text-success" />
                                            Valider
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Finalise un enrôlement en attente de validation.
                                        </p>
                                    </div>
                                </div>
                                <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    Pour accéder aux actions, cliquez sur les trois points (⋮) en fin de ligne.
                                </div>
                                <img
                                    src={AdminEnrolementsListeActions}
                                    alt="Menu administration des enrôlements"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                            </div>

                            <div className="p-4 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaEdit className="mr-2 text-blue-500" />
                                    4. Modification d'un enrôlement
                                </h5>
                                <div className="grid grid-cols-1 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaInfoCircle className="mr-1 text-primary" />
                                            Processus de modification
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-2">
                                            <li>Cliquez sur l'icône <FaEllipsisV className="inline mx-1" /> puis sélectionnez "Modifier"</li>
                                            <li>Le système ouvre l'interface complète de modification avec toutes les informations existantes</li>
                                            <li>Modifiez uniquement les champs nécessaires</li>
                                            <li>Toutes les validations sont appliquées (format des champs, dates, etc.)</li>
                                            <li>Les fichiers existants sont conservés sauf si remplacés</li>
                                        </ul>
                                    </div>
                                    <img
                                        src={AdminEnrolementsModifier}
                                        alt="Menu administration des enrôlements"
                                        className="img-fluid mb-4 border rounded-lg shadow-sm"
                                    />

                                    {/* <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaExclamationTriangle className="mr-1 text-yellow-500" />
                                            Champs critiques
                                        </h6>
                                        <div className="grid grid-cols-2 gap-2 mt-2">
                                            <span className="bg-red-50 text-red-700 px-2 py-1 rounded text-xs">Immatriculation</span>
                                            <span className="bg-red-50 text-red-700 px-2 py-1 rounded text-xs">N° Chassis</span>
                                            <span className="bg-red-50 text-red-700 px-2 py-1 rounded text-xs">Carte grise</span>
                                            <span className="bg-red-50 text-red-700 px-2 py-1 rounded text-xs">Propriétaire</span>
                                        </div>
                                        <p className="mt-2 text-xs text-gray-600">* Ces champs déclenchent une vérification système lors de la modification</p>
                                    </div> */}

                                    {/* <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaHistory className="mr-1 text-purple-500" />
                                            Traçabilité des modifications
                                        </h6>
                                        <p className="text-sm text-gray-700">
                                            Toutes les modifications sont enregistrées dans l'historique avec :
                                        </p>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Date et heure de modification</li>
                                            <li>Utilisateur ayant effectué le changement</li>
                                            <li>Anciennes et nouvelles valeurs pour les champs modifiés</li>
                                        </ul>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    )
                },
                {
                    id: 'admin-suivi-documents',
                    name: 'Suivi Documents',
                    icon: <FaFileAlt className="me-2" />,
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Administration Suivi des documents des véhicules</h2>
                            <img
                                src={AdminMenuSuiviDocuments}
                                alt="Interface suivi des documents"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Ce module complet vous permet de gérer, consulter et renouveler tous les documents obligatoires
                                pour chaque véhicule enrôlé. Le système met en évidence les documents expirés ou sur le point d'expirer
                                pour une gestion proactive des renouvellements.
                            </p>

                            {/* Section 1: Structure et fonctionnalités principales */}
                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h3 className="font-bold text-xl mb-4 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Structure et fonctionnalités principales
                                </h3>

                                <img
                                    src={AdminSuiviDocsImg}
                                    alt="Interface suivi des documents"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h4 className="font-semibold text-lg mb-3 flex items-center">
                                            <FaSearch className="mr-1 text-blue-500" />
                                            Outils de recherche
                                        </h4>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li><strong>Recherche rapide</strong> : Par immatriculation, propriétaire ou téléphone</li>
                                            <img
                                                src={AdminSuiviDocsRechercheImg}
                                                alt="Interface suivi des documents rechercher"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                            <li><strong className="mb-1">Recherche avancée</strong> : Filtres par période d'expiration, immatriculation, etc.</li>
                                            <img
                                                src={AdminSuiviDocsRechercheAvanceeImg}
                                                alt="Interface suivi des documents recherche avancée"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                            <li><strong className="mb-1">Filtres temporels</strong> : Documents expirés, à 7/15/30 jours</li>
                                            <img
                                                src={AdminSuiviDocsFiltreImg}
                                                alt="Interface suivi des documents filtre"
                                                className="img-fluid mt-2 mb-4 border rounded-lg shadow-sm"
                                            />
                                        </ul>
                                    </div>

                                    <div>
                                        <h4 className="font-semibold text-lg mb-3 flex items-center">
                                            <FaInfoCircle className="mr-1 text-green-600" />
                                            Codes couleurs et statuts
                                        </h4>
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                            <div className="text-center">
                                                <span className="badge bg-primary">Valide</span>
                                                <p className="text-sm mt-2 text-gray-700">
                                                    Le document est valide (plus de 30 jours avant expiration)
                                                </p>
                                            </div>
                                            <div className="text-center">
                                                <span className="badge bg-warning">30 jours</span>
                                                <p className="text-sm mt-2 text-gray-700">
                                                    Le document expire dans moins de 30 jours (renouvellement nécessaire)
                                                </p>
                                            </div>
                                            <div className="text-center">
                                                <span className="badge bg-danger">Expiré</span>
                                                <p className="text-sm mt-2 text-gray-700">
                                                    Le document est expiré (renouvellement urgent requis)
                                                </p>
                                            </div>
                                        </div>
                                        <p className="text-sm text-gray-700">
                                            Les couleurs s'affichent dynamiquement en fonction de la date du jour et des dates d'expiration enregistrées.
                                        </p>
                                    </div>
                                </div>

                                <div className="mt-4">
                                    <h4 className="font-semibold text-lg mb-3 flex items-center">
                                        <FaEllipsisV className="mr-2 text-red-500" />
                                        Actions disponibles
                                    </h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <h5 className="font-semibold flex items-center">
                                                <FaSearch className="mr-1 text-green-600" />
                                                Consulter les pièces
                                            </h5>
                                            <p className="mb-3 text-gray-700">
                                                Pour consulter les versions actuelles des pièces d'un véhicule :
                                            </p>
                                            <ol className="list-decimal pl-5 text-sm space-y-1">
                                                <li>Cliquez sur les trois points (⋮) en fin de ligne</li>
                                                <li>Sélectionnez "Consulter" dans le menu</li>
                                                <li>Vous serez redirigé vers la page de consultation</li>
                                            </ol>
                                            <img
                                                src={AdminSuiviDocsBtnConsulterImg}
                                                alt="Bouton consulter"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                        </div>
                                        <div>
                                            <h5 className="font-semibold flex items-center">
                                                <FaFileImport className="mr-1 text-blue-500" />
                                                Renouveler une pièce
                                            </h5>
                                            <p className="mb-3 text-gray-700">
                                                Pour renouveler une pièce expirée (l'option n'apparaît que si au moins un document est expiré) :
                                            </p>
                                            <ol className="list-decimal pl-5 text-sm space-y-1">
                                                <li>Cliquez sur les trois points (⋮) en fin de ligne</li>
                                                <li>Sélectionnez "Renouveler" dans le menu</li>
                                                <li>Vous serez redirigé sur la page de renouvellement</li>
                                            </ol>
                                            <img
                                                src={AdminSuiviDocsActionsImg}
                                                alt="Bouton renouveler"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Section 2: Consultation des pièces */}
                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h3 className="font-bold text-xl mb-4 flex items-center">
                                    <FaFileAlt className="mr-2 text-purple-500" />
                                    2. Consultation des pièces d'un véhicule
                                </h3>

                                <div className="mb-4">
                                    <h4 className="font-semibold text-lg mb-3 flex items-center">
                                        <FaLayerGroup className="mr-2 text-blue-500" />
                                        Accès à la consultation
                                    </h4>
                                    <div className="grid grid-cols-1 gap-4 mb-3">
                                        <div>
                                            <p className="mb-2 font-medium">Étape 1 : Localiser le véhicule</p>
                                            <p className="text-sm text-gray-700">
                                                Dans la liste des documents, repérez la ligne correspondant au véhicule que vous souhaitez consulter.
                                            </p>
                                        </div>
                                        <div>
                                            <p className="mb-2 font-medium">Étape 2 : Ouvrir le menu d'actions</p>
                                            <p className="text-sm text-gray-700">
                                                Cliquez sur les trois points (⋮) situés à la fin de la ligne.
                                            </p>
                                        </div>
                                        <div>
                                            <p className="mb-2 font-medium">Étape 3 : Sélectionner "Consulter"</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h4 className="font-semibold text-lg mb-3">Interface de consultation</h4>
                                    <img
                                        src={SuiviDocsConsulterImg}
                                        alt="Page Consulter"
                                        className="img-fluid mb-4 border rounded-lg shadow-sm"
                                    />

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                        <div>
                                            <h5 className="font-semibold flex items-center">
                                                <FaFileAlt className="mr-1 text-blue-500" />
                                                Onglets documentaires
                                            </h5>
                                            <img
                                                src={SuiviDocsConsulterGaucheImg}
                                                alt="Onglets documents"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                            <p className="mb-3 text-gray-700">
                                                Tous les onglets correspondant aux différents documents du véhicule.
                                                Les icônes changent de couleur selon l'état :
                                            </p>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li><span className="text-dark">Vert</span> : Document valide</li>
                                                <li><span className="text-dark">Rouge</span> : Document expiré</li>
                                                <li><span className="text-dark">Noir</span> : Document non renseigné</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <h5 className="font-semibold flex items-center">
                                                <FaSearch className="mr-1 text-green-600" />
                                                Visualisation des documents
                                            </h5>
                                            <img
                                                src={SuiviDocsConsulterDroiteImg}
                                                alt="Visualisation documents"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                            <p className="mb-3 text-gray-700">
                                                Visualisation des documents PDF ou images associés à l'onglet sélectionné.
                                                Fonctionnalités de zoom et navigation disponibles.
                                            </p>
                                        </div>
                                    </div>

                                    <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                                        <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                        Pour la carte transport, distinction claire entre cartes nationale et internationale.
                                    </div>
                                    <img
                                        src={SuiviDocsConsulterCTImg}
                                        alt="Carte transport"
                                        className="img-fluid mb-4 border rounded-lg shadow-sm"
                                    />
                                </div>
                            </div>

                            {/* Section 3: Renouvellement des pièces */}
                            <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                                <h3 className="font-bold text-xl mb-4 flex items-center">
                                    <FaFileImport className="mr-2 text-red-500" />
                                    3. Renouvellement des pièces expirées
                                </h3>

                                <div className="mb-4">
                                    <h4 className="font-semibold text-lg mb-3 flex items-center">
                                        <FaLayerGroup className="mr-2 text-blue-500" />
                                        Accès au renouvellement
                                    </h4>
                                    <div className="grid grid-cols-1 gap-4 mb-3">
                                        <div>
                                            <p className="mb-2 font-medium">Étape 1 : Localiser le véhicule</p>
                                            <p className="text-sm text-gray-700">
                                                Dans la liste des documents, repérez la ligne avec des documents expirés (badge rouge).
                                            </p>
                                            <img
                                                src={AdminSuiviDocsImg}
                                                alt="Badge rouge expiration"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                        </div>
                                        <div>
                                            <p className="mb-2 font-medium">Étape 2 : Ouvrir le menu d'actions</p>
                                            <p className="text-sm text-gray-700">
                                                Cliquez sur les trois points (⋮) situés à la fin de la ligne.
                                            </p>
                                        </div>
                                        <div>
                                            <p className="mb-2 font-medium">Étape 3 : Sélectionner "Renouveler"</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <h4 className="font-semibold text-lg mb-3">Interface de renouvellement</h4>
                                    <img
                                        src={SuiviDocsRenouvelerImg}
                                        alt="Interface renouvellement"
                                        className="img-fluid mb-4 border rounded-lg shadow-sm"
                                    />

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                        <div>
                                            <h5 className="font-semibold flex items-center">
                                                <FaFileAlt className="mr-1 text-blue-500" />
                                                Onglets documentaires
                                            </h5>
                                            <img
                                                src={SuiviDocsRenouvelerGaucheImg}
                                                alt="Onglets renouvellement"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                            <p className="mb-3 text-gray-700">
                                                Caractéristiques :
                                            </p>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li>Icônes rouges pour documents expirés</li>
                                                <li>Seuls les champs des documents expirés sont modifiables</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <h5 className="font-semibold flex items-center">
                                                <FaUpload className="mr-1 text-green-600" />
                                                Import des nouveaux documents
                                            </h5>
                                            <img
                                                src={SuiviDocsRenouvelerDroiteImg}
                                                alt="Import documents"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                            <p className="mb-3 text-gray-700">
                                                Fonctionnalités :
                                            </p>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li>Bouton "Choisir un fichier" pour les documents expirés</li>
                                                <li>Prévisualisation des nouveaux documents</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="mt-3 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                                        <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                        Pour la carte transport, boutons d'import séparés pour nationale et internationale.
                                    </div>
                                    <img
                                        src={SuiviDocsRenouvelerCTImg}
                                        alt="Carte transport renouvellement"
                                        className="img-fluid mb-4 border rounded-lg shadow-sm"
                                    />
                                </div>

                                <div className="mb-4">
                                    <h4 className="font-semibold text-lg mb-3 flex items-center">
                                        <FaCheckCircle className="mr-1 text-green-500" />
                                        Processus de renouvellement
                                    </h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <h5 className="font-semibold">Sélection des pièces</h5>
                                            <p className="mb-3 text-gray-700">
                                                Après clic sur "Enregistrer", sélectionnez les pièces à renouveler :
                                            </p>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li>Seules les pièces expirées sont proposées</li>
                                                <li>Sélection d'au moins une pièce obligatoire</li>
                                            </ul>
                                            <img
                                                src={SuiviDocsRenouvelerConfirmerImg}
                                                alt="Confirmation renouvellement"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                        </div>
                                        <div>
                                            <h5 className="font-semibold">Validation finale</h5>
                                            <p className="mb-3 text-gray-700">
                                                Vérifications effectuées :
                                            </p>
                                            <ol className="list-decimal pl-5 text-sm space-y-1">
                                                <li>Tous les champs obligatoires remplis</li>
                                                <li>Dates d'expiration dans le futur</li>
                                                <li>Formats de fichiers valides (PDF, JPG, PNG)</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <h4 className="font-semibold text-lg mb-3">Après le renouvellement</h4>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <h5 className="font-semibold flex items-center">
                                                <FaCheck className="mr-1 text-primary" />
                                                Succès
                                            </h5>
                                            <p className="mb-3 text-gray-700">
                                                En cas de réussite :
                                            </p>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li>Message de confirmation</li>
                                                <li>Nouvelles dates enregistrées</li>
                                                <li>Statut passé à "valide"</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <h5 className="font-semibold flex items-center">
                                                <FaExclamationTriangle className="mr-1 text-warning" />
                                                En cas d'erreur
                                            </h5>
                                            <p className="mb-3 text-gray-700">
                                                En cas de problème :
                                            </p>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li>Message d'erreur détaillé</li>
                                                <li>Champs problématiques mis en évidence</li>
                                            </ul>
                                            <img
                                                src={SuiviDocsRenouvelerErreurImg}
                                                alt="Erreur renouvellement"
                                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                },
                {
                    id: 'admin-elementaires',
                    name: 'Élémentaires',
                    icon: <FaCogs className="me-2" />,
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Gestion des données élémentaires</h2>
                            <img
                                src={AdminMenuElementaires}
                                alt="Menu administration des élémentaires"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Ce module permet de gérer les données de référence du système (types de véhicules, assureurs, parcs, etc.).
                                Ces informations servent de base pour tous les autres modules de l'application.
                            </p>

                            {/* Section 1: Présentation générale */}
                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-2 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Vue d'ensemble
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    L'interface des élémentaires présente les différentes catégories de données de référence sous forme de cartes cliquables :
                                </p>
                                <img
                                    src={CartesMenuElementaires}
                                    alt="Administration des élémentaires"
                                    className="img-fluid mb-2 border rounded-lg shadow-sm"
                                />

                                <div className="mt-1 p-3 bg-yellow-50 border-l-4 border-yellow-400">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    Cliquez sur une carte pour accéder à la gestion détaillée de la catégorie correspondante.
                                </div>
                            </div>

                            {/* Section 2: Fonctionnalités communes */}
                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-2 flex items-center">
                                    <FaEllipsisV className="mr-2 text-red-500" />
                                    2. Fonctionnalités communes
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Toutes les interfaces de gestion des élémentaires partagent les mêmes fonctionnalités de base :
                                </p>

                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaPlus className="mr-1 text-green-500" />
                                            Ajout
                                        </h6>
                                        <p className="text-sm text-gray-700">
                                            Bouton "Ajouter" pour créer une nouvelle entrée avec un formulaire dédié.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSearch className="mr-1 text-blue-500" />
                                            Recherche
                                        </h6>
                                        <p className="text-sm text-gray-700">
                                            Champ de recherche pour filtrer les résultats par nom ou critères.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaEdit className="mr-1 text-primary" />
                                            Modification
                                        </h6>
                                        <p className="text-sm text-gray-700">
                                            Option disponible au niveau des actions.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaTrash className="mr-1 text-red-500" />
                                            Suppression
                                        </h6>
                                        <p className="text-sm text-gray-700">
                                            Option disponible au niveau des actions.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaFilter className="mr-1 text-purple-500" />
                                            Tri
                                        </h6>
                                        <p className="text-sm text-gray-700">
                                            Cliquez sur les en-têtes de colonne pour trier les résultats.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaFileAlt className="mr-1 text-orange-500" />
                                            Export
                                        </h6>
                                        <p className="text-sm text-gray-700">
                                            Bouton d'export pour générer des rapports Excel.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Section 3: Types spécifiques */}
                            <div className="p-2">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaShieldAlt className="mr-2 text-red-500" />
                                    3. Catégories disponibles
                                </h5>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <BsCarFront className="mr-2 text-blue-400" />
                                            Types de véhicules
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Définit les catégories de véhicules (Camion, Tracteur, Remorque...)</li>
                                            <li>Influence les options disponibles dans l'enrôlement</li>
                                        </ul>
                                        <img
                                            src={TypeVehicules}
                                            alt="Administration des élémentaires"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <BsBank className="mr-2 text-green-500" />
                                            Assureurs
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Liste des compagnies d'assurance partenaires</li>
                                        </ul>
                                        <img
                                            src={Assureurs}
                                            alt="Administration des élémentaires"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <BsShop className="mr-2 text-orange-500" />
                                            Centres de Fret
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Ecran de fret déclaré</li>
                                        </ul>
                                        <img
                                            src={CentreFret}
                                            alt="Administration des élémentaires"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaRoadBarrier className="mr-2 text-orange-500" />
                                            Parcs
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Zones de stationnement des véhicules</li>
                                        </ul>
                                        <img
                                            src={Parcs}
                                            alt="Administration des élémentaires"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaHandshake className="mr-2 text-purple-500" />
                                            Bailleurs de fret
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Clients principaux pour le transport de marchandises</li>
                                        </ul>
                                        <img
                                            src={BailleurFret}
                                            alt="Administration des élémentaires"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <BsPersonBadge className="mr-2 text-red-400" />
                                            Conducteurs
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Gestion des chauffeurs et leurs informations</li>
                                        </ul>
                                        <img
                                            src={Conducteurs}
                                            alt="Administration des élémentaires"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaLeaf className="mr-2 text-green-400" />
                                            Natures
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Types de marchandises transportées</li>
                                        </ul>
                                        <img
                                            src={NatureFret}
                                            alt="Administration des élémentaires"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                </div>

                                {/* <div className="mt-4 p-3 bg-blue-50 border-l-4 border-blue-400 rounded">
                                    <FaInfoCircle className="inline mr-2 text-blue-500" />
                                    <strong>Conseil :</strong> Maintenez ces données à jour pour garantir le bon fonctionnement des autres modules.
                                </div> */}
                            </div>
                        </div>
                    )
                },
                {
                    id: 'admin-parametres',
                    name: 'Paramétrage',
                    icon: <FaWrench className="me-2" />,
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Configuration des paramètres système</h2>
                            <img
                                src={AdminMenuParametres}
                                alt="Menu administration des paramètres"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Cette interface permet de configurer les paramètres globaux de l'application TransportPro,
                                incluant les notifications, les emails et les préférences d'affichage.
                            </p>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-1 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Structure de l'interface
                                </h5>
                                <p className="mb-2 text-gray-700">
                                    L'interface de paramétrage est organisée en trois onglets principaux :
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                    <div className="p-1 rounded-lg bg-white">
                                        <div className="font-bold">Général</div>
                                        <p className="text-xs text-gray-600 mt-1">
                                            Configuration des emails administratifs
                                        </p>
                                        <img
                                            src={AdminParametresGeneral}
                                            alt="administration des paramètres"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                    <div className="p-1 rounded-lg bg-white">
                                        <div className="font-bold">Notifications</div>
                                        <p className="text-xs text-gray-600 mt-1">
                                            Paramètres des alertes d'expiration
                                        </p>
                                        <img
                                            src={AdminParametresNotifications}
                                            alt="administration des paramètres"
                                            className="img-fluid mb-4 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                    <div className="p-1 rounded-lg bg-white">
                                        <div className="font-bold">Écrans</div>
                                        <p className="text-xs text-gray-600 mt-1">
                                            Configuration des affichages
                                        </p>
                                        <img
                                            src={AdminParametresConfigarion}
                                            alt="administration des paramètres"
                                            className="img-fluid mb-2 border rounded-lg shadow-sm"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaEnvelope className="mr-2 text-green-600" />
                                    2. Configuration des emails
                                </h5>
                                <p className="mb-1 text-gray-700">
                                    Dans l'onglet <strong>Général</strong>, vous pouvez configurer :
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        <strong>Email administrateur</strong> : Adresse principale pour les notifications système
                                    </li>
                                    <li>
                                        <strong>Emails en copie</strong> : Liste des adresses supplémentaires à notifier
                                    </li>
                                </ul>
                                <div className="bg-blue-50 text-xs">
                                    <FaInfoCircle className="inline mr-2" />
                                    Vous pouvez ajouter ou supprimer des adresses avec les boutons + et -
                                </div>
                                <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaExclamationTriangle className="mr-1 text-yellow-500" />
                                            Attention
                                        </h6>
                                        <p className="text-sm text-gray-700">
                                            Les notifications critiques seront envoyées à toutes ces adresses.
                                            Assurez-vous qu'elles sont correctement configurées.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-3 p-2">
                                <h5 className="font-bold mb-2 flex items-center">
                                    <FaBell className="mr-2 text-orange-500" />
                                    3. Paramètres de notification
                                </h5>
                                <p className="mb-2 text-gray-700">
                                    Dans l'onglet <strong>Notification</strong>, configurez les alertes pour les documents expirés :
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                    <div className="">
                                        <div className="font-medium">Niveau 1</div>
                                        <input type="number" className="form-control mt-2 w-50" value="30" readOnly />
                                        <p className="text-xs mt-2 text-gray-700">
                                            Première alerte (jours avant expiration)
                                        </p>
                                    </div>
                                    <div className="">
                                        <div className="font-medium">Niveau 2</div>
                                        <input type="number" className="form-control mt-2 w-50" value="15" readOnly />
                                        <p className="text-xs mt-2 text-gray-700">
                                            Alerte intermédiaire
                                        </p>
                                    </div>
                                    <div className="">
                                        <div className="font-medium">Niveau 3</div>
                                        <input type="number" className="form-control mt-2 w-50" value="7" readOnly />
                                        <p className="text-xs mt-2 text-gray-700">
                                            Alerte urgente
                                        </p>
                                    </div>
                                </div>
                                <div className="">
                                    <FaInfoCircle className="inline mr-2 text-yellow-600" />
                                    Ces paramètres affectent les alertes visuelles dans l'interface et les emails envoyés automatiquement.
                                </div>
                            </div>

                            <div className="mb-2 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-2 flex items-center">
                                    <FaDesktop className="mr-2 text-purple-500" />
                                    4. Configuration des écrans
                                </h5>
                                <p className="mb-3 text-gray-700">
                                    Dans l'onglet <strong>Écran</strong>, paramétrez l'affichage des informations :
                                </p>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaListOl className="mr-1 text-blue-500" />
                                            Nombre d'éléments par page
                                        </h6>
                                        <p className="text-sm text-gray-700 mt-1">
                                            Définit combien d'éléments (véhicules, documents, etc.) sont affichés simultanément dans les listes.
                                        </p>
                                        <input type="number" className="form-control mt-1 w-50" value="10" readOnly />
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center mt-3">
                                            <FaClock className="mr-1 text-green-600" />
                                            Durée d'affichage
                                        </h6>
                                        <p className="text-sm text-gray-700 mt-1">
                                            Temps (en secondes) pendant lequel une page reste visible sur les écrans d'affichage.
                                        </p>
                                        <input type="number" className="form-control mt-1 w-50" value="5" readOnly />
                                    </div>
                                </div>
                            </div>

                            <div className="p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-2 flex items-center">
                                    <FaSave className="mr-2 text-red-500" />
                                    5. Enregistrement des modifications
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaCheck className="mr-1 text-green-500" />
                                            Validation
                                        </h6>
                                        <p className="mb-1 text-gray-700">
                                            Après avoir modifié les paramètres, cliquez sur le bouton "Enregistrer" en bas de page.
                                        </p>
                                        <button className="btn btn-success">
                                            <FaSave className="mr-1" /> Enregistrer
                                        </button>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center mt-3 ">
                                            <FaSync className="mr-1 text-blue-500" />
                                            Application des changements
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Certains paramètres nécessitent un rechargement de la page pour être pleinement effectifs.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                },
                {
                    id: 'admin-journalisation',
                    name: 'Journalisation',
                    icon: <FaHistory className="me-2" />,
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Journal des activités</h2>
                            <img
                                src={AdminMenuJournalisation}
                                alt="Menu administration journalisation"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-2 text-gray-700">
                                Cette interface permet de consulter l'historique complet des actions effectuées par les utilisateurs dans l'application TransportPro.
                                Toutes les modifications importantes sont enregistrées avec leur date, l'utilisateur concerné et les détails de l'action.
                            </p>

                            <div className="mb-1 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaLayerGroup className="mr-2 text-blue-500" />
                                    1. Interface principale
                                </h5>
                                <img
                                    src={AdminJournalisation}
                                    alt="Interface journalisation"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />
                                <p className="mb-1 text-gray-700">
                                    La liste des activités présente les informations essentielles :
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li><strong>Utilisateur</strong> : Nom de l'utilisateur ayant effectué l'action</li>
                                    <li><strong>Action</strong> : Type d'action réalisée (création, modification, suppression...)</li>
                                    <li><strong>Date</strong> : Date et heure précise de l'action</li>
                                    <li><strong>Détails</strong> : Bouton pour accéder aux informations complètes de l'action</li>
                                </ul>
                            </div>

                            <div className="mb-1 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaSearch className="mr-2 text-green-600" />
                                    2. Recherche et filtrage
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaFilter className="mr-1 text-blue-500" />
                                            Filtres disponibles
                                        </h6>
                                        <ul className="list-disc pl-5 text-sm space-y-1">
                                            <li>Par utilisateur</li>
                                            <li>Par type d'action</li>
                                            <li>Par période (date de début et de fin)</li>
                                        </ul>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaSortAmountDown className="mr-1 text-purple-500" />
                                            Tri des résultats
                                        </h6>
                                        <p className="text-sm text-gray-700">
                                            Les résultats peuvent être triés par date (croissant/décroissant) ou par utilisateur.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-1 p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-2 flex items-center">
                                    <FaEllipsisV className="mr-2 text-red-500" />
                                    3. Consultation des détails
                                </h5>
                                <p className="mb-1 text-gray-700">
                                    Pour consulter les détails complets d'une activité :
                                </p>
                                <ol className="list-decimal pl-5 space-y-1">
                                    <li>Cliquez sur les trois points (⋮) en fin de ligne</li>
                                    <li>Sélectionnez "Détails" dans le menu qui apparaît</li>
                                    <li>Une fenêtre modale s'ouvre avec toutes les informations sur l'action</li>
                                </ol>
                                <FaInfoCircle className="inline mr-2" />
                                Les détails incluent souvent les valeurs avant/après modification pour les actions de mise à jour.

                            </div>

                            <div className="p-2 bg-gray-50 rounded-lg">
                                <h5 className="font-bold mb-3 flex items-center">
                                    <FaFileExport className="mr-2 text-blue-500" />
                                    4. Export des données
                                </h5>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaFilePdf className="mr-1 text-danger" />
                                            Format CSV
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Vous pouvez exporter l'ensemble du journal au format CSV pour archivage ou analyse externe.
                                        </p>
                                    </div>
                                    <div>
                                        <h6 className="font-semibold flex items-center">
                                            <FaFilter className="mr-1 text-success" />
                                            Filtrage avant export
                                        </h6>
                                        <p className="mb-3 text-gray-700">
                                            Appliquez d'abord les filtres souhaités avant d'exporter pour ne récupérer que les données pertinentes.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                },
                {
                    id: 'admin-corbeille',
                    name: 'Corbeille',
                    icon: <FaTrash className="me-2" />,
                    content: (
                        <div>
                            <h2 className="text-lg font-bold mb-3">Gestion de la corbeille</h2>
                            <img
                                src={AdminMenuCorbeille}
                                alt="Menu administration corbeille"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />
                            <p className="mb-4 text-gray-700">
                                Ce module permet de gérer certains éléments supprimés dans l'application.
                                Vous pouvez restaurer des éléments ou les supprimer définitivement du système.
                                Il y a actuellement 2 elements qui dispose de corbeille. Vous trouverez donc dans le menu
                                la corbeille des enrolements et la corbeille des frets.
                            </p>
                            <img
                                src={AdminCorbeilleMenu}
                                alt="administration corbeille"
                                className="img-fluid mb-4 border rounded-lg shadow-sm"
                            />

                            {/* Partie 1 - Corbeille des enrôlements */}
                            <div className="p-4 mt-2 rounded-lg">
                                <h3 className="text-xl font-bold mb-4 flex items-center">
                                    <FaTruck className="mr-2 text-blue-500" />
                                    1. Corbeille des enrôlements
                                </h3>
                                <img
                                    src={AdminCorbeilleMenuEnrolement}
                                    alt="administration corbeille"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />

                                <div className="mb-4 bg-gray-50 rounded-lg">
                                    <h5 className="font-bold mb-3 flex items-center">
                                        <FaLayerGroup className="mr-2 text-blue-500" />
                                        Interface des enrôlements supprimés
                                    </h5>
                                    <img
                                        src={AdminCorbeilleEnrolement}
                                        alt="administration corbeille"
                                        className="img-fluid mb-4 border rounded-lg shadow-sm"
                                    />
                                    <p className="mb-3 text-gray-700">
                                        Le tableau présente les informations clés sur chaque véhicule supprimé :
                                    </p>
                                    <ul className="list-disc pl-5 space-y-1 mb-4">
                                        <li><strong>Immatriculation :</strong> Numéro d'identification du véhicule</li>
                                        <li><strong>Nationalité :</strong> Origine du véhicule</li>
                                        <li><strong>Type de véhicule :</strong> Catégorie du véhicule</li>
                                        <li><strong>Propriétaire :</strong> Nom du détenteur du véhicule</li>
                                        <li><strong>Téléphone :</strong> Contact du propriétaire</li>
                                        <li><strong>Carte transport :</strong> Référence du document</li>
                                        <li><strong>Date expiration :</strong> Validité de la carte transport</li>
                                        <li><strong>Ajouté par :</strong> Utilisateur ayant enregistré le véhicule</li>
                                    </ul>
                                </div>

                                <div className="mb-4 bg-gray-50 rounded-lg">
                                    <h5 className="font-bold mb-3 flex items-center">
                                        <FaSearch className="mr-2 text-green-600" />
                                        Fonctionnalités disponibles
                                    </h5>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <h6 className="font-semibold flex items-center">
                                                <FaSearch className="mr-1 text-blue-500" />
                                                Recherche et tri
                                            </h6>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li>Recherche textuelle sur tous les champs</li>
                                                <li>Tri par colonne (cliquer sur l'en-tête)</li>
                                                <li>Filtrage par date de suppression</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <h6 className="font-semibold flex items-center">
                                                <FaFilter className="mr-1 text-purple-500" />
                                                Affichage
                                            </h6>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li>Pagination (10, 20 ou 50 éléments/page)</li>
                                                <li>Navigation entre les pages</li>
                                                <li>Indicateur de position dans la liste</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-3 bg-gray-50 rounded-lg">
                                    <h5 className="font-bold mb-3 flex items-center">
                                        <FaEllipsisV className="mr-2 text-red-500" />
                                        Actions possibles
                                    </h5>
                                    <img
                                        src={AdminCorbeilleEnrolementActions}
                                        alt="administration corbeille"
                                        className="img-fluid mb-4 border rounded-lg shadow-sm"
                                    />
                                    <div className="grid grid-cols-1 md:grid-cols-2 mb-4">
                                        <div>
                                            <h6 className="font-semibold flex items-center">
                                                <FaSync className="mr-1 text-green-500" />
                                                Restaurer un enrôlement
                                            </h6>
                                            <p className="mb-1">
                                                Permet de réintégrer un véhicule supprimé dans la liste principale.
                                            </p>
                                            <ol className="list-decimal pl-5 text-sm">
                                                <li>Cliquez sur les trois points (⋮) en fin de ligne</li>
                                                <li>Sélectionnez "Restaurer"</li>
                                                <li>Confirmez l'opération dans la boîte de dialogue</li>
                                            </ol>
                                            <div className="mb-3">
                                                <FaInfoCircle className="inline mr-2 text-green-600" />
                                                Le véhicule retrouvera son statut actif dans le système.
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <h6 className="mt-4 font-semibold flex items-center">
                                                <FaTrash className="mr-1 text-red-500" />
                                                Suppression définitive
                                            </h6>
                                            <p className="mb-2 text-gray-700">
                                                Efface irréversiblement l'enrôlement du véhicule et toutes ses données.
                                            </p>
                                            <ol className="list-decimal pl-5 text-sm">
                                                <li>Cliquez sur les trois points (⋮) en fin de ligne</li>
                                                <li>Sélectionnez "Supprimer définitivement"</li>
                                                <li>Confirmez l'action dans la boîte de dialogue</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-gray-50 rounded-lg mt-3">
                                    <h5 className="font-bold mb-3 flex items-center">
                                        <FaShieldAlt className="mr-2 text-red-500" />
                                        Politique de conservation
                                    </h5>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <h6 className="font-semibold flex items-center">
                                                <FaClock className="mr-1 text-primary" />
                                                Durée de rétention
                                            </h6>
                                            <p className="text-gray-700">
                                                Les enrôlements supprimés sont conservés pendant 30 jours avant suppression automatique.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Partie 2 - Corbeille des frets */}
                            <div className="p-2 rounded-lg">
                                <h3 className="text-xl font-bold mb-4 flex items-center">
                                    <FaBoxes className="mr-2 text-blue-500" />
                                    2. Corbeille des frets
                                </h3>
                                <img
                                    src={AdminCorbeilleMenuFret}
                                    alt="administration corbeille"
                                    className="img-fluid mb-4 border rounded-lg shadow-sm"
                                />

                                <div className="mb-3 bg-gray-50 rounded-lg">
                                    <h5 className="font-bold mb-3 flex items-center">
                                        <FaLayerGroup className="mr-2 text-blue-500" />
                                        Interface des frets supprimés
                                    </h5>
                                    <img
                                        src={AdminCorbeilleFret}
                                        alt="administration corbeille"
                                        className="img-fluid mb-4 border rounded-lg shadow-sm"
                                    />
                                    <p className="mb-3 text-gray-700">
                                        Le tableau affiche les informations clés sur chaque fret supprimé :
                                    </p>
                                    <ul className="list-disc pl-5 space-y-1 mb-4">
                                        <li><strong>Référence :</strong> Identifiant unique du fret</li>
                                        <li><strong>Type :</strong> National ou international</li>
                                        <li><strong>Bailleur :</strong> Organisation à l'origine du fret</li>
                                        <li><strong>Destinataire :</strong> Organisation bénéficiaire</li>
                                        <li><strong>Trajet :</strong> Villes de départ et d'arrivée</li>
                                        <li><strong>Dates :</strong> Période prévue de transport</li>
                                        <li><strong>Statut :</strong> Indiqué comme "Corbeille"</li>
                                        <li><strong>Camions restants :</strong> Nombre de véhicules non assignés</li>
                                        <li><strong>Ajouté par :</strong> Utilisateur ayant créé le fret</li>
                                    </ul>
                                </div>

                                <div className="mb-4 p-4 bg-gray-50 rounded-lg">
                                    <h5 className="font-bold mb-3 flex items-center">
                                        <FaSearch className="mr-2 text-green-600" />
                                        Fonctionnalités disponibles
                                    </h5>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <h6 className="font-semibold flex items-center">
                                                <FaSearch className="mr-1 text-blue-500" />
                                                Recherche et tri
                                            </h6>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li>Recherche textuelle sur tous les champs</li>
                                                <li>Tri par colonne (cliquer sur l'en-tête)</li>
                                                <li>Filtrage par date de suppression</li>
                                            </ul>
                                        </div>
                                        <div>
                                            <h6 className="font-semibold flex items-center">
                                                <FaFilter className="mr-1 text-purple-500" />
                                                Affichage
                                            </h6>
                                            <ul className="list-disc pl-5 text-sm space-y-1">
                                                <li>Pagination (10, 20 ou 50 éléments/page)</li>
                                                <li>Navigation entre les pages</li>
                                                <li>Indicateur de position dans la liste</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-4 bg-gray-50 rounded-lg">
                                    <h5 className="font-bold mb-3 flex items-center">
                                        <FaEllipsisV className="mr-2 text-red-500" />
                                        Actions possibles
                                    </h5>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="mb-4">
                                            <h6 className="font-semibold flex items-center">
                                                <FaSync className="mr-1 text-green-500" />
                                                Restaurer un fret
                                            </h6>
                                            <p className="mb-1 text-gray-700">
                                                Permet de réintégrer un fret supprimé dans la liste principale.
                                            </p>
                                            <ol className="list-decimal pl-5 text-sm space-y-1">
                                                <li>Sélectionnez le fret à restaurer</li>
                                                <li>Cliquez sur "Restaurer" dans le menu d'actions</li>
                                                <li>Confirmez l'opération dans la boîte de dialogue</li>
                                            </ol>
                                            <div className="bg-green-50 border-l-4 border-green-400 rounded">
                                                <FaInfoCircle className="inline mr-2 text-green-600" />
                                                Le fret retrouvera son statut précédent avant suppression.
                                            </div>
                                        </div>
                                        <div>
                                            <h6 className="font-semibold flex items-center">
                                                <FaTrash className="mr-1 text-red-500" />
                                                Suppression définitive
                                            </h6>
                                            <p className="mb-1 text-gray-700">
                                                Efface irréversiblement le fret et toutes ses données associées.
                                            </p>
                                            <ol className="list-decimal pl-5 text-sm space-y-1">
                                                <li>Sélectionnez le fret à supprimer</li>
                                                <li>Cliquez sur "Supprimer définitivement"</li>
                                                <li>Confirmez l'action dans la boîte de dialogue</li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>

                                <div className="bg-gray-50 rounded-lg mt-3">
                                    <h5 className="font-bold mb-3 flex items-center">
                                        <FaShieldAlt className="mr-2 text-red-500" />
                                        Politique de conservation
                                    </h5>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <h6 className="font-semibold flex items-center">
                                                <FaClock className="mr-1 text-primary" />
                                                Durée de rétention
                                            </h6>
                                            <p className="mb-3 text-gray-700">
                                                Les frets supprimés sont conservés pendant 30 jours avant suppression automatique.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            ]
        }
    ];

    const [showMobileMenu, setShowMobileMenu] = useState(false);

    const getActiveContent = () => {
        const module = modules.find(m => m.id === activeModule);
        if (!module) return null;

        // Afficher toujours le contenu direct du module s'il existe
        if (module.content) return module.content;

        // Si le module a des sections mais qu'elles sont fermées, afficher la première section quand même
        if (module.sections?.length > 0) {
            const sectionToShow = activeSection || module.sections[0].id;
            return (
                <div>
                    {module.sections.map(section => (
                        <div
                            key={section.id}
                            id={`section-${section.id}`}
                            className="mb-8"
                        >
                            {sectionToShow === section.id && section.content}
                        </div>
                    ))}
                </div>
            );
        }

        return null;
    };

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex align-items-center">
                                <FaBook size={25} className="mr-2" />
                                Manuel d'utilisation
                            </h2>
                            <div className="">
                                <small>
                                    Ce manuel explique les fonctionnalités principales de l'application TransportPro.
                                </small>
                            </div>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        Manuel d'utilisation
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row">
                            <div className="col-lg-12">
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '10px',
                                    marginBottom: '10px',
                                    flexWrap: 'wrap'
                                }}>
                                    <Button
                                        variant="secondary"
                                        onClick={() => navigate(-1)}
                                        style={{ padding: '5px 10px' }}
                                    >
                                        <FaArrowLeft className="me-1" /> Retour
                                    </Button>

                                    {/* Bouton menu mobile */}
                                    <Button
                                        variant="primary"
                                        onClick={() => setShowMobileMenu(!showMobileMenu)}
                                        style={{
                                            padding: '5px 10px',
                                            display: window.innerWidth < 992 ? 'block' : 'none'
                                        }}
                                    >
                                        <FaBars className="me-1" /> Menu
                                    </Button>
                                </div>

                                <div className="ibox">
                                    <div className="ibox-content">
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: window.innerWidth < 992 ? 'column' : 'row',
                                            gap: '20px'
                                        }}>
                                            {/* Menu latéral */}
                                            <div style={{
                                                width: window.innerWidth < 992 ? '100%' : '250px',
                                                // maxHeight: '650px',
                                                // overflowY: 'auto',
                                                display: window.innerWidth < 992 ? (showMobileMenu ? 'block' : 'none') : 'block',
                                                position: window.innerWidth < 992 ? 'relative' : 'sticky',
                                                top: '20px',
                                                alignSelf: 'flex-start'
                                            }}>
                                                <div className="list-group list-group-flush">
                                                    {modules.map(module => (
                                                        <div key={module.id} style={{ marginBottom: '5px' }}>
                                                            <button
                                                                onClick={() => {
                                                                    setActiveModule(module.id);
                                                                    if (module.sections) {
                                                                        toggleSection(module.id);
                                                                    } else {
                                                                        setActiveSection(null);
                                                                    }
                                                                    if (window.innerWidth < 992) {
                                                                        setShowMobileMenu(false);
                                                                    }
                                                                }}
                                                                style={{
                                                                    width: '100%',
                                                                    textAlign: 'left',
                                                                    padding: '12px',
                                                                    border: 'none',
                                                                    background: 'transparent',
                                                                    fontWeight: activeModule === module.id ? '600' : '400',
                                                                    color: '#333',
                                                                    fontSize: '1rem',
                                                                    display: 'flex',
                                                                    alignItems: 'center'
                                                                }}
                                                            >
                                                                {module.icon}
                                                                <span style={{ marginLeft: '8px', marginRight: '4px' }}>{module.name}</span>
                                                                {/* {module.sections && (
                                                                    <span style={{ marginLeft: 'auto' }}>
                                                                        {openSections[module.id] ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                                                                    </span>
                                                                )} */}
                                                                {module.sections && module.sections.length > 0 && (
                                                                    <span className="ms-auto">
                                                                        {openSections[module.id] ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                                                                    </span>
                                                                )}
                                                            </button>

                                                            {module.sections && openSections[module.id] && module.sections.map(section => (
                                                                <button
                                                                    key={section.id}
                                                                    onClick={() => {
                                                                        setActiveModule(module.id);
                                                                        setActiveSection(section.id);
                                                                        if (window.innerWidth < 992) {
                                                                            setShowMobileMenu(false);
                                                                        }
                                                                    }}
                                                                    style={{
                                                                        width: '100%',
                                                                        textAlign: 'left',
                                                                        padding: '8px 8px 8px 40px',
                                                                        fontSize: '0.95rem',
                                                                        fontWeight: activeSection === section.id ? '600' : '400',
                                                                        color: activeSection === section.id ? '#1a365d' : '#333',
                                                                        border: 'none',
                                                                        background: 'transparent'
                                                                    }}
                                                                >
                                                                    {section.name}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Contenu principal */}
                                            <div style={{
                                                flex: 1,
                                                padding: '16px',
                                                marginLeft: window.innerWidth < 992 ? '0' : '20px',
                                                maxWidth: '100%',
                                                overflowX: 'hidden'
                                            }}>
                                                <div className="prose max-w-none">
                                                    {getActiveContent()}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManuelUtilisationAdmin;